// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-28T17:36:15.717Z
// Property: Rancho Belago (ID: 5739272128692224)
// Collections: 48 amenities, 4 floorplans (live), 30 photos, 37 POIs, 3 reviews, 2 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "5739272128692224",
  "property_external_id": "872256",
  "property_zillow_url": "https://www.zillow.com/apartments/moreno-valley-ca/rancho-belago/5XjV2y/",
  "property_apartments_url": "https://www.apartments.com/rancho-belago-moreno-valley-ca/pls745s",
  "property_google_business_url": "https://www.google.com/maps/place/Rancho+Belago/data=!4m2!3m1!1s0x0:0xc7bf0677aedc819f?sa=X&ved=2ahUKEwi5nffH-riSAxVxSDABHRqQNTUQ_BJ6BAhGEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47578684069",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "rancho-belago",
  "property_name": "Rancho Belago",
  "property_website_url": "https://www.ranchobelagoapts.com",
  "property_domain": "https://www.ranchobelagoapts.com",
  "property_address": "27625 E Trail Ridge Way",
  "property_full_address": "27625 E Trail Ridge Way, Moreno Valley, CA, 92555",
  "property_address_1": "27625 E Trail Ridge Way",
  "property_address_2": null,
  "property_address_city": "Moreno Valley",
  "property_address_state": "CA",
  "property_address_zip_full": null,
  "property_address_zip": "92555",
  "property_address_country": "US",
  "property_address_county": "Riverside County",
  "property_neighborhood_address": "Moreno Valley East",
  "property_address_latitude": "33.9338",
  "property_address_longitude": "-117.1795",
  "property_email": "rancho@weidner.com",
  "property_phone": "8402362621",
  "property_call_tracking_phone": "951-379-5020",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Discover your perfect home at Rancho Belago in Moreno Valley, CA! Choose from thoughtfully designed one, two, or three-bedroom floor plans featuring granite countertops and modern amenities. Enjoy our vibrant resident lounge, fitness center, hiking trail, and planned social activities. Find your new home today—browse availability or schedule a tour!",
  "property_long_description": "**Welcome to Rancho Belago – Your Ideal Apartment Home in Moreno Valley, CA!**\n\nDiscover the perfect blend of comfort, convenience, and luxury at Rancho Belago, where our thoughtfully designed floor plans cater to every lifestyle. Choose from our spacious one, two, or three-bedroom apartments, each equipped with modern amenities to elevate your living experience. From stunning granite countertops and sleek black kitchen appliances to inviting wood plank flooring and air conditioning, you'll find everything you need for effortless living in your new home.\n\nStep outside your door to enjoy a vibrant community that fosters connection and relaxation. Our inviting resident lounge is perfect for unwinding or socializing, while our planned social activities ensure there’s always something fun on the calendar. Get your fitness routine in gear with our state-of-the-art cardio and weight machines, or immerse yourself in nature with nearby hiking trails. Enjoy added peace of mind with our gated access, intercom call box, and sprinkler systems in place.\n\nEnhance your daily life with convenient amenities like our coffee station, conference room, and available carport. Every detail at Rancho Belago is designed to support a warm and welcoming atmosphere that feels like home.\n\nLocated in the heart of Moreno Valley, our community is the ideal place for you to thrive. Don’t miss out on the opportunity to experience Rancho Belago for yourself. **Find your new home today – browse our availability or schedule a tour to visit our community!**",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d2094-ae06-7009-be1a-436526ad12e6.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas",
    "public_id": "019d2094-ae06-7009-be1a-436526ad12e6",
    "storage_key": "property/5739272128692224/019d2094-ae06-7009-be1a-436526ad12e6.webp",
    "width": 1497,
    "height": 547
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "246",
  "property_year_built": "2007",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.4959349593496",
  "property_admin_fee": null,
  "property_application_fee": "55",
  "property_fees_deposit_info": "600-900",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "500",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Cats and dogs are allowed; however, breed restrictions apply. Pets must be under certain weight limits.",
  "property_pet_policy_description": "Cats and dogs are welcome! Pets – max 2 allowed. Monthly pet rent: $50 per pet. Refundable pet deposit: $500 for first pet, $300 for second pet. No one‑time pet fee or weight limit. Breed restrictions apply (e.g., Pit Bull & mixes, American Staffordshire Terrier, Wolf Hybrids, Doberman Pinscher, Saint Bernard, American Bulldog, Staffordshire Bull Terrier, Rottweiler, German Shepherd, Chow Chow, Great Dane, Akita). Certified service dogs allowed; reasonable accommodations considered case‑by‑case.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://ranchobelagoapts.securecafe.com/onlineleasing/rancho-belago-0/floorplans.aspx",
  "property_resident_portal_url": "https://ranchobelagoapts.securecafenet.com/residentservices/rancho-belago-0/userlogin",
  "property_apply_now_url": "https://ranchobelagoapts.securecafe.com/onlineleasing/rancho-belago-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-5b6c-71ba-bee5-3855c7adf9d5.webp",
  "property_primary_logo_media": {
    "alt_text": "Rancho Belago Apartment Homes logo",
    "public_id": "019d01a2-5b6c-71ba-bee5-3855c7adf9d5",
    "storage_key": "property/5739272128692224/019d01a2-5b6c-71ba-bee5-3855c7adf9d5.webp",
    "width": 372,
    "height": 75
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-4d01-73c0-b82f-7ebfcf01cadc.webp",
  "property_secondary_logo_media": {
    "alt_text": "Weidner Apartment Homes logo with stylized buildings and text.",
    "public_id": "019d01a3-4d01-73c0-b82f-7ebfcf01cadc",
    "storage_key": "property/5739272128692224/019d01a3-4d01-73c0-b82f-7ebfcf01cadc.webp",
    "width": 325,
    "height": 97
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-5808-766c-b25e-ab27c2e3766f.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Rancho Belago Apartment Homes logo",
    "public_id": "019d01a3-5808-766c-b25e-ab27c2e3766f",
    "storage_key": "property/5739272128692224/019d01a3-5808-766c-b25e-ab27c2e3766f.webp",
    "width": 372,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-6062-7618-9755-d3c51f8be720.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Rancho Belago Apartment Homes logo",
    "public_id": "019d01a3-6062-7618-9755-d3c51f8be720",
    "storage_key": "property/5739272128692224/019d01a3-6062-7618-9755-d3c51f8be720.webp",
    "width": 372,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#6f3e3e",
  "property_secondary_color": "#e6dfd8",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#a97f89",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": " - 1187",
  "property_sqft_min": "708",
  "property_sqft_max": "1187",
  "property_price_range": "1785 - 3050",
  "property_price_min": "1785",
  "property_price_max": "3050",
  "property_available_units": 24,
  "property_facebook_url": "https://www.facebook.com/RanchoBelagoApartments",
  "property_instagram_url": "https://www.instagram.com/ranchobelagoapartments/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/Rancho+Belago/@33.9336385,-117.1798539,1292m/data=!3m1!1e3!4m15!1m8!3m7!1s0x80dca78c8767657d:0xf32db7d0f1eb1736!2s27625+Trail+Ridge+Way,+Moreno+Valley,+CA+92555!3b1!8m2!3d33.9336385!4d-117.1798539!16s%2Fg%2F11cncngvlq!3m5!1s0x80dca78c64069c41:0xc7bf0677aedc819f!8m2!3d33.9340396!4d-117.1800778!16s%2Fg%2F1thkxknj!5m1!1e1?entry=ttu&g_ep=EgoyMDI2MDQyMi4wIKXMDSoASAFQAw%3D%3D",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Rancho Belago",
  "property_home_romance_title": "Embrace the Comfort of Your New Apartments Today",
  "property_home_amenities_blurb": "Welcome to Rancho Belago in Moreno Valley, CA, where spacious one, two, and three-bedroom apartments meet exceptional community living. Enjoy 24-hour access, a fitness center, a refreshing pool, and planned social activities amidst stunning views. Experience comfort, convenience, and the vibrant lifestyle you deserve—your new home awaits!",
  "property_home_floorplans_blurb": "At Rancho Belago in Moreno Valley, CA, your ideal living space awaits. Choose from thoughtfully designed one, two, or three-bedroom floor plans that blend comfort and style. Unveil a lifestyle tailored to your needs—browse our available homes and uncover the perfect match for your next chapter.",
  "property_home_gallery_blurb": "At Rancho Belago in Moreno Valley, CA, choose from spacious one, two, or three-bedroom floor plans designed for modern living. Enjoy top-notch amenities like a fitness center, resort-style pool, and engaging community activities. With 24-hour maintenance and energy-efficient features, your ideal lifestyle awaits—imagine making this your home!",
  "property_home_neighborhood_blurb": "Discover your perfect home at Rancho Belago in Moreno Valley, CA! Our diverse floor plans—one, two, and three bedrooms—cater to every lifestyle. See what's around our community and explore local favorites and nearby points of interest that make living here truly special. Your new adventure begins today!",
  "property_home_reviews_blurb": "Experience the vibrant lifestyle at Rancho Belago in Moreno Valley, where resort-style living meets comfort. Our residents rave about the “amazing amenities” like a luxurious pool, state-of-the-art gym, and a cozy movie theater. Join a community that prioritizes your happiness and explore what makes us a top-rated choice!",
  "property_neighborhood_blurb": "At Rancho Belago in Moreno Valley, you'll find more than just diverse floor plans—live among vibrant local attractions. From top-rated schools like Valley Christian Academy to the exhilarating Firestorm Freerunning, your new home offers an active lifestyle surrounded by parks and unique shops. Experience the community’s rich tapestry today!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Discover the vibrant life at Rancho Belago in Moreno Valley, CA! Choose from spacious one, two, or three-bedroom floor plans and enjoy exceptional amenities like a resident lounge, fitness center, coffee station, and scenic hiking trails. Explore our amazing community amenities and apartment features today!",
  "property_applynow_blurb": "Discover your ideal living space at Rancho Belago in Moreno Valley, CA! Choose from one, two, or three-bedroom floor plans with stunning amenities like a resident lounge, state-of-the-art fitness center, and hiking trails. Find your new home and lease online today! Experience luxury living at its finest!",
  "property_contactus_blurb": "Discover your perfect home at Rancho Belago in Moreno Valley, CA! Choose from our spacious one, two, or three-bedroom floor plans tailored for your lifestyle. Have questions? Contact our leasing team today to learn more about availability and community amenities! Your dream apartment awaits at Rancho Belago!",
  "property_faqs_blurb": "Welcome to Rancho Belago in Moreno Valley, CA, where you'll discover diverse floor plans including one, two, and three-bedroom apartments. Interested in learning more? Browse our FAQs page for answers to your most pressing questions about our vibrant community and find the perfect home for you today!",
  "property_floorplans_blurb": "Discover your ideal living space at Rancho Belago in Moreno Valley, CA. Choose from spacious one, two, or three-bedroom floor plans designed for comfort and style. Browse our available apartment homes today and find the perfect layout that fits your lifestyle. Your new home awaits at Rancho Belago!",
  "property_gallery_blurb": "Discover your perfect home at Rancho Belago in Moreno Valley, CA, featuring stylish one, two, and three-bedroom floor plans. Enjoy premium amenities like a resident lounge, fitness center, and scenic hiking trails. Picture yourself living here—explore our photo gallery today and envision your new lifestyle!",
  "property_interactivemap_blurb": "Discover your ideal home at Rancho Belago in Moreno Valley, CA! Choose from stylish one, two, or three-bedroom floor plans, complete with modern amenities like granite countertops, a resident lounge, and a scenic hiking trail. Explore our interactive community map today to find your perfect apartment and pricing!",
  "property_pets_blurb": "Welcome to Rancho Belago, where your Moreno Valley sanctuary awaits! Enjoy stylish living surrounded by lush landscapes and modern amenities. Our pet-friendly community invites your furry companions to join your adventure, with select breed restrictions to ensure harmony. Experience comfort and convenience at Rancho Belago—your ideal home awaits!",
  "property_referafriend_blurb": "At Rancho Belago in Moreno Valley, CA, we offer a variety of spacious floor plans, including one, two, and three-bedroom apartments. Great friends make great neighbors—refer a friend to our vibrant community today and share the joy of living in your new home! Explore all our options now!",
  "property_residentaccess_blurb": "Welcome to Rancho Belago in Moreno Valley, CA! Explore our diverse floor plans featuring one, two, and three-bedroom apartments tailored to your lifestyle. Need assistance? Access your resident portal today to pay rent, schedule maintenance, and enjoy convenient living at its best!",
  "property_reviews_blurb": "At Rancho Belago in Moreno Valley, residents revel in a resort-style living experience. One happy tenant celebrated the “amazing amenities,” including a luxurious pool and well-equipped gym. With spacious apartments and stunning mountain views, it’s no wonder residents choose to call Rancho Belago home. See what our residents have to say about living at our community!",
  "property_created_at": "1749055614575",
  "property_scheduletour_blurb": "Discover your perfect home at Rancho Belago in Moreno Valley, CA! Explore our diverse floor plans, including spacious one, two, and three-bedroom apartments. Schedule a tour today and see what our residents love about living in our vibrant community. Your dream home awaits at Rancho Belago!",
  "property_thankyou_blurb": "Thank you for your interest in Rancho Belago! Our Moreno Valley community offers a variety of floor plans, including one, two, and three-bedroom apartments designed for your comfort. Explore your options and find your perfect home in this vibrant location. A team member will reach out soon to assist you!",
  "property_virtualtours_blurb": "Explore Rancho Belago in Moreno Valley, CA, where our diverse floor plans include spacious one, two, and three-bedroom apartments. Discover your ideal home today! Take a virtual tour of our community and apartments for rent to experience the comfort and style that awaits you. Don’t miss out!",
  "property_copyright": "2025 All Rights Reserved. Rancho Belago",
  "property_seo_title_home": "Rancho Belago Apartments in San Jacinto - 27625 E. Trail Ridge Way | California.Weidner.com",
  "property_seo_description_home": "Rancho Belago Apartments: Check out photos, availability, pricing amenities, and reviews for Rancho Belago Apartments in Moreno Valley East, CA.\n",
  "property_seo_title_floorplans": "Floor Plans | Rancho Belago Apartments in Moreno Valley East | Weidner\n",
  "property_seo_description_floorplans": "View our available one, two, and three bedroom apartment floorplans for rent at Rancho Belago Apartments today! Find the one that's right for you!\n",
  "property_seo_title_amenities": "Rancho Belago | Amenities | Moreno Valley, CA | Weidner\n",
  "property_seo_description_amenities": "Rancho Belago has a wide range of apartment and community amenities to choose from. Visit us and make Rancho Belago your new home.\n",
  "property_seo_title_gallery": "Photo Gallery | Rancho Belago in Moreno Valley East, CA | Weidner\n",
  "property_seo_description_gallery": "Explore our high-resolution photo gallery to get a sneak peek at Rancho Belago Apartments in Moreno Valley East. See our amenities and community today!\n",
  "property_seo_title_virtualtours": "Virtual Tours | Rancho Belago Apartments",
  "property_seo_description_virtualtours": "Discover your perfect home at Rancho Belago in Moreno Valley, CA! Explore our stunning one, two, and three-bedroom floor plans through a virtual tour. Experience the community and apartments for rent today—your dream space awaits! Take a virtual tour now!",
  "property_seo_title_interactivemap": "Interactive Leasing | Rancho Belago Apartments | Moreno Valley, CA",
  "property_seo_description_interactivemap": "Click through our interactive leasing map to explore floor plan options and availability at Rancho Belago Apartments in Moreno Valley.",
  "property_seo_title_neighborhood": "Rancho Belago | Map and Directions | Moreno Valley, CA | Weidner",
  "property_seo_description_neighborhood": "If you're shopping apartments for rent in Moreno Valley, then look no further than beautiful Rancho Belago. Get a map of the neighborhood here!\n",
  "property_seo_title_contact": "Rancho Belago | Contact Us | Moreno Valley, CA | Weidner\n",
  "property_seo_description_contact": "If you're shopping apartments for rent in Moreno Valley CA, look no further than beautiful Rancho Belago. Contact us today to view your new apartment home.\n",
  "property_seo_title_faqs": "FAQ | Rancho Belago Apartments | Moreno Valley, CA\n",
  "property_seo_description_faqs": "Got questions? Our FAQ page has answers about floor plans, leasing, amenities, and more at Rancho Belago Apartments in Moreno Valley.",
  "property_seo_title_reviews": "Reviews | Rancho Belago Apartments | Moreno Valley, CA",
  "property_seo_description_reviews": "See what residents are saying about Rancho Belago Apartments in Moreno Valley, CA. Our community is loved—and you’ll see why!",
  "property_seo_title_applynow": "Apply Now | Rancho Belago Apartments | Moreno Valley, CA",
  "property_seo_description_applynow": "Spacious one, two, and three-bedroom floor plans are waiting for you at Rancho Belago Apartments. Your new home is at your fingertips. Apply now!",
  "property_seo_title_residentaccess": "Resident Access | Rancho Belago Apartments | Moreno Valley, CA\n",
  "property_seo_description_residentaccess": "Pay rent and submit maintenance requests easily online with 24/7 access through the resident portal. Log in now!",
  "property_seo_title_referafriend": "Refer a Friend | Rancho Belago Apartments | Moreno Valley, CA\n",
  "property_seo_description_referafriend": "Love living at Rancho Belago Apartments? Refer a friend and enjoy the rewards! Learn more about our referral perks.",
  "property_seo_title_scheduletour": "Schedule a Tour | Rancho Belago Apartments | Moreno Valley, CA\n",
  "property_seo_description_scheduletour": "Come see your new home in person! Schedule a tour of Rancho Belago Apartments in Moreno Valley online or by calling our team.",
  "property_seo_title_privacy": "Privacy Policy | Rancho Belago Apartments | Moreno Valley, CA",
  "property_seo_description_privacy": "We value your privacy. Read our privacy policy to see how we protect your information and provide secure apartment browsing.\n\n",
  "property_seo_title_accessibility": "Accessibility | Rancho Belago Apartments | Moreno Valley, CA\n",
  "property_seo_description_accessibility": "Our Moreno Valley apartment website was designed with accessibility in mind. View our accessibility features here.",
  "property_seo_title_sitemap": "Sitemap | Rancho Belago Apartments | Moreno Valley, CA\n",
  "property_seo_description_sitemap": "Easily explore our site and find your next apartment in Moreno Valley with our website sitemap.",
  "property_seo_title_thankyou": "Thank You | Rancho Belago Apartments | Moreno Valley, CA\n",
  "property_seo_description_thankyou": "Thank you for contacting us! A member of our leasing team will reach out shortly to help you find your new home in Moreno Valley.",
  "property_seo_title_pets": "Pet Policy | Apartments in Moreno Valley, CA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293633382",
  "amenities": [
    {
      "id": "ec_3dacdb1285b6b6ba050fbea5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258837",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d99d6-ed99-728a-9849-678fb36dce9b.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables under umbrellas",
        "public_id": "019d99d6-ed99-728a-9849-678fb36dce9b",
        "storage_key": "property/5739272128692224/019d99d6-ed99-728a-9849-678fb36dce9b.webp",
        "width": 1152,
        "height": 768
      },
      "amenity_image_alt_text": "Rancho Belago Pool",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7011a459ee105daefe23bbd4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258835",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d99d6-ecd3-733e-81ad-05e2325f5d72.webp",
      "amenity_image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, and weight machines.",
        "public_id": "019d99d6-ecd3-733e-81ad-05e2325f5d72",
        "storage_key": "property/5739272128692224/019d99d6-ecd3-733e-81ad-05e2325f5d72.webp",
        "width": 1152,
        "height": 768
      },
      "amenity_image_alt_text": "Rancho Belago Fitnes Center",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5b83e788c174de385806cd1a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258834",
      "title": "Barbecue/Grill Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d99d6-ecde-76a2-aabd-6effdab3ac53.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor pool area with lounge chairs, umbrellas, tables, and grills.",
        "public_id": "019d99d6-ecde-76a2-aabd-6effdab3ac53",
        "storage_key": "property/5739272128692224/019d99d6-ecde-76a2-aabd-6effdab3ac53.webp",
        "width": 1152,
        "height": 768
      },
      "amenity_image_alt_text": "Rancho Belago BBQ Area",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3e6579f8082e3c986e932ab0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86259274",
      "title": "Garage*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d99d6-eb09-7675-8a21-232268bfc95b.webp",
      "amenity_image_media": {
        "alt_text": "Row of garage doors with tan and beige panels",
        "public_id": "019d99d6-eb09-7675-8a21-232268bfc95b",
        "storage_key": "property/5739272128692224/019d99d6-eb09-7675-8a21-232268bfc95b.webp",
        "width": 1152,
        "height": 768
      },
      "amenity_image_alt_text": "Rancho Belago Garage",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ac826970bfdce774c0b816f7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86259273",
      "title": "Surface Lot, Covered - Carport",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d99d6-ec00-7264-9c86-ada3cb1b50b6.webp",
      "amenity_image_media": {
        "alt_text": "Covered parking and garages at a multifamily property.",
        "public_id": "019d99d6-ec00-7264-9c86-ada3cb1b50b6",
        "storage_key": "property/5739272128692224/019d99d6-ec00-7264-9c86-ada3cb1b50b6.webp",
        "width": 1152,
        "height": 768
      },
      "amenity_image_alt_text": "Rancho Belago Covered Parking",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_227fcd5bf25acb3209df89b9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258829",
      "title": "Movie Theater",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d99d6-fc15-7402-8c00-e763451457ef.webp",
      "amenity_image_media": {
        "alt_text": "Theater room with reclining chairs and projector screen.",
        "public_id": "019d99d6-fc15-7402-8c00-e763451457ef",
        "storage_key": "property/5739272128692224/019d99d6-fc15-7402-8c00-e763451457ef.webp",
        "width": 1152,
        "height": 768
      },
      "amenity_image_alt_text": "Rancho Belago Media Room",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2d12f7161b67056985dda03b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258813",
      "title": "Controlled Access Building",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c9d8fc0b20f6f09e83f784d5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258818",
      "title": "On-site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7eb275e54efef51b5c8cca79",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258819",
      "title": "On-site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3f0d4be5464aa2d8a6136289",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258821",
      "title": "Recycling",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bb7c0b1253c63f150d6b6a08",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258825",
      "title": "Courtesy Patrol",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_71baa6d37ba226c72f8239a0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258828",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4fa8837b45d7cf556dc11cdc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258830",
      "title": "Reserveable Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_51de3a774452b2b92c920f10",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258836",
      "title": "Free Weights",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8d4d78bef8095f17688c0df7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258838",
      "title": "Spa/Hot Tub",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_25e3136fe749f71715ed6f67",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258833",
      "title": "Resident Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-5003-719d-b2fc-20881f8dddd9.webp",
      "amenity_image_media": {
        "alt_text": "Community lounge with a billiards table, seating area, and fireplace.",
        "public_id": "019d01a2-5003-719d-b2fc-20881f8dddd9",
        "storage_key": "property/5739272128692224/019d01a2-5003-719d-b2fc-20881f8dddd9.webp",
        "width": 1152,
        "height": 768
      },
      "amenity_image_alt_text": "Rancho Belago Resident Lounge",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_220234f0bb3e63f274594cd3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "88141772",
      "title": "Carport*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c6bcf246291c5775019a5a0e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258816",
      "title": "Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c458974f36b13fc1f08d040f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258826",
      "title": "Planned Social Activities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a6eceed13461ed270dbed607",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258831",
      "title": "Coffee Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_92f3fd5f2613357475f742ee",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258832",
      "title": "Conference Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_efdb3b5a9888fd848e1cdeae",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258839",
      "title": "Cardio Machines",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e45cefa8f13be753ddb2642d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258840",
      "title": "Weight Machines",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9582ce4c1c59141dae3103df",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258844",
      "title": "Hiking Trail",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0839c6f357dee19d6a17e23c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "124800061",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f3a7d8a3ce027018a344cea9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258876",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d99d6-fb93-715f-99a6-c40fcb6bb290.webp",
      "amenity_image_media": {
        "alt_text": "Bathroom with a bathtub and toilet, adjacent to a walk-in closet.",
        "public_id": "019d99d6-fb93-715f-99a6-c40fcb6bb290",
        "storage_key": "property/5739272128692224/019d99d6-fb93-715f-99a6-c40fcb6bb290.webp",
        "width": 1152,
        "height": 768
      },
      "amenity_image_alt_text": "Rancho Belago Master Bathroom and Closet",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d4331c5f942d95e18dc74b84",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258849",
      "title": "Gas Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_92eafc4748c9f271d28b8f48",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258848",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d90e5416ce4b62d78a88fec6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258850",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_25a67067df79cf126bd14f50",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258851",
      "title": "Energy Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_487d8064a3e1f133b933108e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258869",
      "title": "Central AC and Heating per apartment",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2609b84b084fbdd8c5abe8db",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258870",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5b0f62f46ef0df94bd1a2b96",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258873",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4ad82a675eb9ed17669b3c30",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258874",
      "title": "Views",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e87b8ac0e963e546adde9ad9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258875",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_83be6362ac9cea8e016db142",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258885",
      "title": "Window Covering",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ba9b4bac8356b3f6514125d5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258871",
      "title": "Fireplace",
      "amount": "false",
      "description": "Fireplace",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a1-7458-7461-8c4a-202bead61e6a.webp",
      "amenity_image_media": {
        "alt_text": "Living room with a fireplace, a TV, a sofa, a leather armchair, and a coffee table.",
        "public_id": "019d01a1-7458-7461-8c4a-202bead61e6a",
        "storage_key": "property/5739272128692224/019d01a1-7458-7461-8c4a-202bead61e6a.webp",
        "width": 1920,
        "height": 1280
      },
      "amenity_image_alt_text": "Rancho Belago Fireplace",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a3fb6523c9ac5a3e34fe5e18",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258864",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a1-7584-74d7-86c3-79459a33ec26.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, and black appliances.",
        "public_id": "019d01a1-7584-74d7-86c3-79459a33ec26",
        "storage_key": "property/5739272128692224/019d01a1-7584-74d7-86c3-79459a33ec26.webp",
        "width": 1920,
        "height": 1280
      },
      "amenity_image_alt_text": "Rancho Belago Kitchen",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_763119e5a0b14879883038a1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258855",
      "title": "Ice Maker",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ea872d09381940fe604decb7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258862",
      "title": "Pantry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aad7877dd1bfa5d63c1f0609",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258867",
      "title": "Black Kitchen Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_994334df66b4714a865364ca",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258877",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ad03ce1c7a69caa184fea1d5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258879",
      "title": "Dining Room",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_78c2a7627a9b6cb409801000",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258880",
      "title": "Intercom/Call Box",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9b18b3ee7b10467fad2a0f51",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258881",
      "title": "Sprinkler System",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_529007e83d90faf1e33a418d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258883",
      "title": "Crown Molding",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_497252a981088d0d7c13864e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "86258884",
      "title": "Track Lighting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_92c88ddaa79a9b70c2f927f0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "yardi",
      "external_id": "87940523",
      "title": "Wood Plank Flooring*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_5883c9f203ce1791064107e7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a1-7458-7461-8c4a-202bead61e6a.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, a TV, a sofa, a leather armchair, and a coffee table.",
        "public_id": "019d01a1-7458-7461-8c4a-202bead61e6a",
        "storage_key": "property/5739272128692224/019d01a1-7458-7461-8c4a-202bead61e6a.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace with a tile surround, a mounted TV, a plush sofa, a leather armchair, and a wooden coffee table.",
      "link": "false",
      "alt_text": "Living room with a fireplace, a TV, a sofa, a leather armchair, and a coffee table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Rancho-Belago_Favorites (1).jpg"
    },
    {
      "id": "ec_f737bd825edb9563933c59ec",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d32d6-53b1-74de-8aa9-fd46d06b37d5.webp",
      "image_media": {
        "alt_text": "Spring into Savings! Up to one month free on select homes with a 14 month lease. Equal Housing Opportunity logo.",
        "public_id": "019d32d6-53b1-74de-8aa9-fd46d06b37d5",
        "storage_key": "property/5739272128692224/019d32d6-53b1-74de-8aa9-fd46d06b37d5.webp",
        "width": 1084,
        "height": 684
      },
      "title": "Other",
      "description": "Spring into savings with up to one month free on select homes when you sign a 14-month lease. Limited time offer. Restrictions apply. Contact the leasing office for details. Equal Housing Opportunity.",
      "link": "false",
      "alt_text": "Spring into Savings! Up to one month free on select homes with a 14 month lease. Equal Housing Opportunity logo.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/Specials (3088).png"
    },
    {
      "id": "ec_98f77153fa7abd4cc13783d2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a1-7847-74eb-bbf4-5065102377f8.webp",
      "image_media": {
        "alt_text": "Living room with striped sofa, coffee table, fireplace, and dining area visible.",
        "public_id": "019d01a1-7847-74eb-bbf4-5065102377f8",
        "storage_key": "property/5739272128692224/019d01a1-7847-74eb-bbf4-5065102377f8.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable striped sofa, a decorative coffee table, a modern fireplace, and an adjacent dining area with a table and chairs.",
      "link": "false",
      "alt_text": "Living room with striped sofa, coffee table, fireplace, and dining area visible.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Rancho-Belago_Favorites (2).jpg"
    },
    {
      "id": "ec_6049253551a44797aaad3408",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a1-7584-74d7-86c3-79459a33ec26.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, and black appliances.",
        "public_id": "019d01a1-7584-74d7-86c3-79459a33ec26",
        "storage_key": "property/5739272128692224/019d01a1-7584-74d7-86c3-79459a33ec26.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring ample cabinet space, granite countertops, and a full suite of black appliances, including a microwave, oven, and refrigerator.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, and black appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Rancho-Belago_Favorites (3).jpg"
    },
    {
      "id": "ec_19c8a61de0e211cc38b118ed",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a1-80f6-7548-b9b4-d3c99155ac9d.webp",
      "image_media": {
        "alt_text": "King-size bed with ornate headboard and patterned bedding in a well-appointed bedroom.",
        "public_id": "019d01a1-80f6-7548-b9b4-d3c99155ac9d",
        "storage_key": "property/5739272128692224/019d01a1-80f6-7548-b9b4-d3c99155ac9d.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully furnished bedroom, featuring a king-size bed with luxurious bedding and elegant decor.",
      "link": "false",
      "alt_text": "King-size bed with ornate headboard and patterned bedding in a well-appointed bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Rancho-Belago_Favorites (4).jpg"
    },
    {
      "id": "ec_504abdc2dd2562f9af3613d9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a1-8283-7529-848d-4d82ca2f0d94.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, nightstand, lamp, and a walk-in closet.",
        "public_id": "019d01a1-8283-7529-848d-4d82ca2f0d94",
        "storage_key": "property/5739272128692224/019d01a1-8283-7529-848d-4d82ca2f0d94.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed, a convenient walk-in closet, and elegant decor, perfect for relaxation.",
      "link": "false",
      "alt_text": "Bedroom with a large bed, nightstand, lamp, and a walk-in closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Rancho-Belago_Favorites (5).jpg"
    },
    {
      "id": "ec_884ccfc96c3d4522356a4f5f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a1-844a-7552-973f-67d89d06efc3.webp",
      "image_media": {
        "alt_text": "Bathroom with white vanity, toilet, and bathtub.",
        "public_id": "019d01a1-844a-7552-973f-67d89d06efc3",
        "storage_key": "property/5739272128692224/019d01a1-844a-7552-973f-67d89d06efc3.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity, toilet, and a separate bathtub with an ornate shower curtain. The flooring is a light wood-look tile, complemented by decorative rugs and artwork.",
      "link": "false",
      "alt_text": "Bathroom with white vanity, toilet, and bathtub.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Rancho-Belago_Favorites (6).jpg"
    },
    {
      "id": "ec_f0f5eb501541f8db0b24fc73",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a1-9b4f-7088-9306-4c4ba789415f.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, sink, toilet, and walk-in closet.",
        "public_id": "019d01a1-9b4f-7088-9306-4c4ba789415f",
        "storage_key": "property/5739272128692224/019d01a1-9b4f-7088-9306-4c4ba789415f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a modern vanity with a sink, a toilet, and a large walk-in closet. An elegant light fixture illuminates the space, and a decorative orchid adds a touch of sophistication.",
      "link": "false",
      "alt_text": "Bathroom with vanity, sink, toilet, and walk-in closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Rancho-Belago_Favorites (7).JPG"
    },
    {
      "id": "ec_c7015d39ee28d0295988b5b9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a1-a45b-72fd-b941-a8999fa2808f.webp",
      "image_media": {
        "alt_text": "Bathroom with a dual vanity, large mirror, and a bathtub/shower combination.",
        "public_id": "019d01a1-a45b-72fd-b941-a8999fa2808f",
        "storage_key": "property/5739272128692224/019d01a1-a45b-72fd-b941-a8999fa2808f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in the spacious bathroom, featuring a dual vanity with ample counter space and a bathtub/shower combination. Perfect for unwinding after a long day.",
      "link": "false",
      "alt_text": "Bathroom with a dual vanity, large mirror, and a bathtub/shower combination.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Rancho-Belago_Favorites (8).JPG"
    },
    {
      "id": "ec_b45849454f60b86fa678f4b9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a1-a891-7719-85c8-8bd4b40e90b6.webp",
      "image_media": {
        "alt_text": "Clean and bright apartment bathroom with a bathtub, shower, toilet, and vanity.",
        "public_id": "019d01a1-a891-7719-85c8-8bd4b40e90b6",
        "storage_key": "property/5739272128692224/019d01a1-a891-7719-85c8-8bd4b40e90b6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This apartment bathroom features a clean white bathtub and shower, a functional toilet, and a spacious vanity with a modern faucet.",
      "link": "false",
      "alt_text": "Clean and bright apartment bathroom with a bathtub, shower, toilet, and vanity.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Rancho-Belago_Favorites (9).JPG"
    },
    {
      "id": "ec_ffe9c4c40040276f7a370174",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a1-afd3-721e-a1f7-cea84087cd47.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with a fireplace and island counter.",
        "public_id": "019d01a1-afd3-721e-a1f7-cea84087cd47",
        "storage_key": "property/5739272128692224/019d01a1-afd3-721e-a1f7-cea84087cd47.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room with a cozy fireplace and an island counter perfect for entertaining guests.",
      "link": "false",
      "alt_text": "Living room and kitchen area with a fireplace and island counter.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Rancho-Belago_Favorites (10).JPG"
    },
    {
      "id": "ec_91b4924c8b3ee4b3cc977c72",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a1-beb7-732f-a5e3-55dbffc8a63d.webp",
      "image_media": {
        "alt_text": "Spacious living area and kitchen with modern appliances and dark wood cabinets.",
        "public_id": "019d01a1-beb7-732f-a5e3-55dbffc8a63d",
        "storage_key": "property/5739272128692224/019d01a1-beb7-732f-a5e3-55dbffc8a63d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience the perfect blend of comfort and style in this open-concept living space, featuring a gourmet kitchen with dark wood cabinets and ample counter space.",
      "link": "false",
      "alt_text": "Spacious living area and kitchen with modern appliances and dark wood cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Rancho-Belago_Favorites (11).JPG"
    },
    {
      "id": "ec_ee621f9fa6a1c93c6d2e7864",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a1-dde5-726f-a0f4-92043c8f978c.webp",
      "image_media": {
        "alt_text": "Spacious living room with carpet, a ceiling fan, and large windows.",
        "public_id": "019d01a1-dde5-726f-a0f4-92043c8f978c",
        "storage_key": "property/5739272128692224/019d01a1-dde5-726f-a0f4-92043c8f978c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy this bright and airy living space, perfect for relaxing or entertaining. Features include plush carpeting, a ceiling fan for comfort, and large windows.",
      "link": "false",
      "alt_text": "Spacious living room with carpet, a ceiling fan, and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Rancho-Belago_Favorites (12).JPG"
    },
    {
      "id": "ec_6f36344383b2c920675eeae2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a1-e0de-732f-ae07-fec3b3468341.webp",
      "image_media": {
        "alt_text": "Kitchen and laundry area with wooden cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019d01a1-e0de-732f-ae07-fec3b3468341",
        "storage_key": "property/5739272128692224/019d01a1-e0de-732f-ae07-fec3b3468341.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring elegant wooden cabinetry, granite countertops, and a breakfast bar. Includes a convenient in-unit laundry area.",
      "link": "false",
      "alt_text": "Kitchen and laundry area with wooden cabinets, granite countertops, and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Rancho-Belago_Favorites (13).JPG"
    },
    {
      "id": "ec_4e2cdb60bbdc8ea6359273ca",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a1-cea8-7639-86f4-8b75ef6a95dd.webp",
      "image_media": {
        "alt_text": "Empty bedroom with beige walls, neutral carpet, and a large window with blinds.",
        "public_id": "019d01a1-cea8-7639-86f4-8b75ef6a95dd",
        "storage_key": "property/5739272128692224/019d01a1-cea8-7639-86f4-8b75ef6a95dd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This unfurnished bedroom features neutral carpeting and a large window with blinds, ready for your personal touch.",
      "link": "false",
      "alt_text": "Empty bedroom with beige walls, neutral carpet, and a large window with blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Rancho-Belago_Favorites (14).JPG"
    },
    {
      "id": "ec_6390c8def3c34fb8d9a4c55c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a1-e238-734f-bf23-3efa5907814b.webp",
      "image_media": {
        "alt_text": "Empty apartment bedroom with neutral walls and carpet, and blinds on windows.",
        "public_id": "019d01a1-e238-734f-bf23-3efa5907814b",
        "storage_key": "property/5739272128692224/019d01a1-e238-734f-bf23-3efa5907814b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This spacious apartment bedroom features neutral tones and ample natural light from the large windows with blinds, creating a serene atmosphere.",
      "link": "false",
      "alt_text": "Empty apartment bedroom with neutral walls and carpet, and blinds on windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Rancho-Belago_Favorites (15).JPG"
    },
    {
      "id": "ec_c6bd0d7ab7da5dda92fb1616",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a1-eb88-7408-834d-8aef488ff043.webp",
      "image_media": {
        "alt_text": "Empty bedroom with ceiling fan and window.",
        "public_id": "019d01a1-eb88-7408-834d-8aef488ff043",
        "storage_key": "property/5739272128692224/019d01a1-eb88-7408-834d-8aef488ff043.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom with plush carpeting, a ceiling fan, and a large window, ready for your personal touch.",
      "link": "false",
      "alt_text": "Empty bedroom with ceiling fan and window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Rancho-Belago_Favorites (16).JPG"
    },
    {
      "id": "ec_bb8ee26a5a703d0689cb8749",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a1-f690-73ad-a99f-3c19fb3281e4.webp",
      "image_media": {
        "alt_text": "In-unit laundry with washer and dryer",
        "public_id": "019d01a1-f690-73ad-a99f-3c19fb3281e4",
        "storage_key": "property/5739272128692224/019d01a1-f690-73ad-a99f-3c19fb3281e4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer for your laundry needs.",
      "link": "false",
      "alt_text": "In-unit laundry with washer and dryer",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Rancho-Belago_Favorites (17).JPG"
    },
    {
      "id": "ec_fd6a0436ed440283832a4a20",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a1-f1a0-769f-a4ae-d951aba3cb0f.webp",
      "image_media": {
        "alt_text": "Gym equipment including treadmills, ellipticals, and weight machines in a well-lit fitness center.",
        "public_id": "019d01a1-f1a0-769f-a4ae-d951aba3cb0f",
        "storage_key": "property/5739272128692224/019d01a1-f1a0-769f-a4ae-d951aba3cb0f.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a wide range of cardio and strength training equipment for a complete workout.",
      "link": "false",
      "alt_text": "Gym equipment including treadmills, ellipticals, and weight machines in a well-lit fitness center.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Rancho-Belago_Favorites (21).jpg"
    },
    {
      "id": "ec_7968235ff7625a63da53d1c3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a1-f464-748b-9e0d-c17053bc091b.webp",
      "image_media": {
        "alt_text": "Community lounge with pool table, fireplace, and seating area.",
        "public_id": "019d01a1-f464-748b-9e0d-c17053bc091b",
        "storage_key": "property/5739272128692224/019d01a1-f464-748b-9e0d-c17053bc091b.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring a billiards table, cozy fireplace, and comfortable seating perfect for socializing.",
      "link": "false",
      "alt_text": "Community lounge with pool table, fireplace, and seating area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Rancho-Belago_Favorites (22).jpg"
    },
    {
      "id": "ec_5f4bf67b19c593a09c5f004e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a1-f9d7-756c-a088-f07b8bd1c0fb.webp",
      "image_media": {
        "alt_text": "Tiered seating with plush leather chairs and a projector screen in a community media room.",
        "public_id": "019d01a1-f9d7-756c-a088-f07b8bd1c0fb",
        "storage_key": "property/5739272128692224/019d01a1-f9d7-756c-a088-f07b8bd1c0fb.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy movie nights in the community's private theater, featuring comfortable seating and a large screen for an immersive viewing experience.",
      "link": "false",
      "alt_text": "Tiered seating with plush leather chairs and a projector screen in a community media room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Rancho-Belago_Favorites (23).jpg"
    },
    {
      "id": "ec_0a38f2d919437044434b44ae",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a1-fe19-707f-9f8f-0c9cda1f330a.webp",
      "image_media": {
        "alt_text": "Business center with computers, printer, and desk space.",
        "public_id": "019d01a1-fe19-707f-9f8f-0c9cda1f330a",
        "storage_key": "property/5739272128692224/019d01a1-fe19-707f-9f8f-0c9cda1f330a.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Utilize our convenient business center, equipped with computers and a printer for all your work needs.",
      "link": "false",
      "alt_text": "Business center with computers, printer, and desk space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Rancho-Belago_Favorites (24).jpg"
    },
    {
      "id": "ec_7bc874efd08dc5d2491e34d5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-0f84-7051-a4e8-6c1241a9fea2.webp",
      "image_media": {
        "alt_text": "Rancho Belago apartment community entrance with palm trees and landscaping.",
        "public_id": "019d01a2-0f84-7051-a4e8-6c1241a9fea2",
        "storage_key": "property/5739272128692224/019d01a2-0f84-7051-a4e8-6c1241a9fea2.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Welcome to Rancho Belago, where lush landscaping and palm trees create a serene atmosphere at the community entrance.",
      "link": "false",
      "alt_text": "Rancho Belago apartment community entrance with palm trees and landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Rancho-Belago_Favorites (34).jpg"
    },
    {
      "id": "ec_b1e2090d6a3e675a05e7c1b5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-0a3d-744f-bd2e-482cc6091b24.webp",
      "image_media": {
        "alt_text": "Rancho Belago property entrance with palm trees and lush landscaping.",
        "public_id": "019d01a2-0a3d-744f-bd2e-482cc6091b24",
        "storage_key": "property/5739272128692224/019d01a2-0a3d-744f-bd2e-482cc6091b24.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Welcome to Rancho Belago, a vibrant community featuring beautiful landscaping and a welcoming entrance.",
      "link": "false",
      "alt_text": "Rancho Belago property entrance with palm trees and lush landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Rancho-Belago_Favorites (41).jpg"
    },
    {
      "id": "ec_0f740f1011c65c32df8b47b2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-0d61-759c-af36-c19ad41171f8.webp",
      "image_media": {
        "alt_text": "Exterior of the apartment building with palm trees and parking lot.",
        "public_id": "019d01a2-0d61-759c-af36-c19ad41171f8",
        "storage_key": "property/5739272128692224/019d01a2-0d61-759c-af36-c19ad41171f8.webp",
        "width": 1499,
        "height": 1000
      },
      "title": "Community",
      "description": "Welcome to our beautiful apartment complex, featuring a stunning exterior design with lush landscaping and ample parking.",
      "link": "false",
      "alt_text": "Exterior of the apartment building with palm trees and parking lot.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Rancho-Belago_Favorites (40).jpg"
    },
    {
      "id": "ec_eee144d8e833803da9213e5f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-0f6d-72e8-ae68-604c7b0d8187.webp",
      "image_media": {
        "alt_text": "Entrance of apartment building with accessible parking spaces.",
        "public_id": "019d01a2-0f6d-72e8-ae68-604c7b0d8187",
        "storage_key": "property/5739272128692224/019d01a2-0f6d-72e8-ae68-604c7b0d8187.webp",
        "width": 1500,
        "height": 999
      },
      "title": "Community",
      "description": "The welcoming entrance of our apartment building, featuring beautifully landscaped grounds and convenient accessible parking.",
      "link": "false",
      "alt_text": "Entrance of apartment building with accessible parking spaces.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Rancho-Belago_Favorites (39).jpg"
    },
    {
      "id": "ec_8fd111303b0edb231c33b91b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-1f42-7641-8df9-7751c234fa07.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019d01a2-1f42-7641-8df9-7751c234fa07",
        "storage_key": "property/5739272128692224/019d01a2-1f42-7641-8df9-7751c234fa07.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush landscaping and comfortable lounge chairs. Perfect for relaxation and fun.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Rancho-Belago_Favorites (38).jpg"
    },
    {
      "id": "ec_595ba8fbb70779da79e84706",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-1c45-734a-abcf-da0870657cb6.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with a walkway and landscaping.",
        "public_id": "019d01a2-1c45-734a-abcf-da0870657cb6",
        "storage_key": "property/5739272128692224/019d01a2-1c45-734a-abcf-da0870657cb6.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Welcome to your new home! Explore the beautiful exteriors and well-maintained grounds of our community.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with a walkway and landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Rancho-Belago_Favorites (37).jpg"
    },
    {
      "id": "ec_00a1845dd03e4e22e11bb321",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-259e-7549-9013-34c0a4ed7370.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019d01a2-259e-7549-9013-34c0a4ed7370",
        "storage_key": "property/5739272128692224/019d01a2-259e-7549-9013-34c0a4ed7370.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush landscaping and comfortable lounge areas.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Rancho-Belago_Favorites (36).jpg"
    },
    {
      "id": "ec_3e513f42b3b601375e21d6bb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-29d7-76fe-8365-e60718ca3cbf.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019d01a2-29d7-76fe-8365-e60718ca3cbf",
        "storage_key": "property/5739272128692224/019d01a2-29d7-76fe-8365-e60718ca3cbf.webp",
        "width": 1497,
        "height": 997
      },
      "title": "Community",
      "description": "Enjoy our beautiful resort-style swimming pool, perfect for relaxing and soaking up the sun. Featuring comfortable lounge chairs and shaded areas.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CA_Rancho-Belago_Favorites (35).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_445f8405-0d38-441a-9373-1bc25299f841",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "23035 Hemlock Ave, Moreno Valley, CA 92557, USA",
      "poi_short_description": "Classic burger chain serving customizable burgers, hand-cut fries & shakes.",
      "poi_long_description": "People say this hamburger restaurant serves delicious burgers and animal-style fries. They highlight the fresh, simple ingredients and the consistent quality of the food. They also like the friendly and efficient service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-d4e1-7009-966d-f4d9b6ae9175.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-d4e1-7009-966d-f4d9b6ae9175",
        "storage_key": "property/5739272128692224/019d01a2-d4e1-7009-966d-f4d9b6ae9175.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.in-n-out.com/44",
      "poi_directions_map_url": "https://maps.google.com/?cid=16056191596360804414&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "33.9421386",
      "poi_longitude": "-117.2601545",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-0e41-731d-b575-7fccd4c4791d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-0e41-731d-b575-7fccd4c4791d",
        "storage_key": "property/5739272128692224/019d01a3-0e41-731d-b575-7fccd4c4791d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN1o8ZuRJ6IARPqiyAjAN094",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_1d4dcda3-b9df-4631-bb6c-fbf349fde572",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "22690 Centerpoint Dr, Moreno Valley, CA 92553, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious ribs, prime rib, and ribeye steaks. They also highlight the generous portions, reasonable prices, and fun, lively atmosphere.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-d4b2-73a6-8c9b-a5c3043cabca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-d4b2-73a6-8c9b-a5c3043cabca",
        "storage_key": "property/5739272128692224/019d01a2-d4b2-73a6-8c9b-a5c3043cabca.webp",
        "width": 1280,
        "height": 758
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/california/morenovalley?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=14056647902467653292&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "33.94023",
      "poi_longitude": "-117.2668401",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 951-421-0038",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-0e41-731d-b575-7fccd4c4791d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-0e41-731d-b575-7fccd4c4791d",
        "storage_key": "property/5739272128692224/019d01a3-0e41-731d-b575-7fccd4c4791d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvX-rQ7Op3IARrP5Sv8o-E8M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_18b8f08c-5cac-437a-a0d1-fd0d99665ff5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "Portillo's Moreno Valley",
      "poi_type": "Restaurants",
      "poi_address": "12840 Day St, Moreno Valley, CA 92553, USA",
      "poi_short_description": "Chicago-born chain for hot dogs, Italian beef sandwiches & more, plus beer & wine, in retro digs.",
      "poi_long_description": "People say this fast food restaurant serves delicious Chicago-style hot dogs, Italian beef sandwiches, and chocolate cake shakes. They highlight the fair prices and nostalgic atmosphere. They also like the friendly and efficient service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-d509-77ac-ba6e-a1ca1dd011c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-d509-77ac-ba6e-a1ca1dd011c6",
        "storage_key": "property/5739272128692224/019d01a2-d509-77ac-ba6e-a1ca1dd011c6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.portillos.com/locations/moreno-valley/?utm_source=google&utm_medium=yext&utm_campaign=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=8280577726960812556&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "portillos-moreno-valley",
      "poi_latitude": "33.934499",
      "poi_longitude": "-117.2782796",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 951-653-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-0e41-731d-b575-7fccd4c4791d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-0e41-731d-b575-7fccd4c4791d",
        "storage_key": "property/5739272128692224/019d01a3-0e41-731d-b575-7fccd4c4791d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhTEH6lev3IARDMKC_pGF6nI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_43f71a7e-58c6-4130-8354-cdf832b68622",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "12625 Frederick St Bldg. T1, Moreno Valley, CA 92553, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves good chicken fingers, fries, and Cane's sauce. They also highlight the fast and friendly service, and the clean dining area.\n\nSome reviews mention the chicken can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-d3ec-714c-802f-d7cd7a51f695.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-d3ec-714c-802f-d7cd7a51f695",
        "storage_key": "property/5739272128692224/019d01a2-d3ec-714c-802f-d7cd7a51f695.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ca/moreno-valley/12625-frederick-st",
      "poi_directions_map_url": "https://maps.google.com/?cid=5318492561169423525&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "33.9376077",
      "poi_longitude": "-117.2618554",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 951-497-4978",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-0e41-731d-b575-7fccd4c4791d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-0e41-731d-b575-7fccd4c4791d",
        "storage_key": "property/5739272128692224/019d01a3-0e41-731d-b575-7fccd4c4791d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ56iNF6qp3IARpZwPSc4Uz0k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_bef5df51-e58e-4f3f-ac97-f68d60f7cdb8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "BJ's Restaurant & Brewhouse",
      "poi_type": "Restaurants",
      "poi_address": "22920 Centerpoint Dr, Moreno Valley, CA 92553, USA",
      "poi_short_description": "Family-friendly chain outpost pairs familiar pub fare with an extensive list of house brews.",
      "poi_long_description": "People say this restaurant serves delicious pizza, burgers, and Pizookies. They also highlight the friendly service and fun, lively atmosphere.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-d9c8-771c-aeb1-86eba7689c76.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-d9c8-771c-aeb1-86eba7689c76",
        "storage_key": "property/5739272128692224/019d01a2-d9c8-771c-aeb1-86eba7689c76.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.bjsrestaurants.com/locations/ca/moreno-valley?utm_source=google&utm_medium=organic&utm_campaign=google_my_business",
      "poi_directions_map_url": "https://maps.google.com/?cid=12385912166981957725&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bjs-restaurant--brewhouse",
      "poi_latitude": "33.9395542",
      "poi_longitude": "-117.2624835",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 951-571-9370",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-0e41-731d-b575-7fccd4c4791d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-0e41-731d-b575-7fccd4c4791d",
        "storage_key": "property/5739272128692224/019d01a3-0e41-731d-b575-7fccd4c4791d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfeH9OKqo3IARXfglFH6Z46s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_1e1ae527-0408-4195-b8d0-a887c1243613",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "Moreno Valley Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "22500 Town Cir, Moreno Valley, CA 92553, USA",
      "poi_short_description": "Old-school retail complex offering brand-name stores, a food court, a multiplex cinema & bowling.",
      "poi_long_description": "People say this shopping center offers a variety of stores, a movie theater, and a food court. They also highlight the live music in the food court, the massage chairs, and the family-friendly amenities, such as a kids' play area and arcade.\n\nOther reviews mention the restrooms can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-d9fd-77cd-9fda-3e80075cc312.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-d9fd-77cd-9fda-3e80075cc312",
        "storage_key": "property/5739272128692224/019d01a2-d9fd-77cd-9fda-3e80075cc312.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.morenovalleymall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4650153310421277230&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "moreno-valley-mall",
      "poi_latitude": "33.9387132",
      "poi_longitude": "-117.2710454",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 951-653-1177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-0e65-713b-9b6d-450742e0d481.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-0e65-713b-9b6d-450742e0d481",
        "storage_key": "property/5739272128692224/019d01a3-0e65-713b-9b6d-450742e0d481.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ0e85WVSv3IARLlrEWsypiEA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_47bdc2df-5ea3-4665-9d95-c7b0be267fe9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "12880 Day St, Moreno Valley, CA 92553, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "People say this supermarket offers a wide variety of items, including fresh produce, a deli, bakery, and a bulk section. They highlight the affordable prices and the convenient 24/7 operating hours. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-dbc7-7277-9da3-3f4c71d97476.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-dbc7-7277-9da3-3f4c71d97476",
        "storage_key": "property/5739272128692224/019d01a2-dbc7-7277-9da3-3f4c71d97476.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8327926201443612084&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "33.9337025",
      "poi_longitude": "-117.2752068",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 951-867-3066",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-0e4b-707a-927b-60f27b7da10d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-0e4b-707a-927b-60f27b7da10d",
        "storage_key": "property/5739272128692224/019d01a3-0e4b-707a-927b-60f27b7da10d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr3x6m_il3IARtPW2yMG8knM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_8660f9ed-a861-4428-94ca-cbdc66253ca1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "12255 Pigeon Pass Rd, Moreno Valley, CA 92557, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide variety of tools and supplies. They also highlight the friendly and helpful staff, and the clean and organized store.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-dbc7-7277-9da3-4033ace48dd6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-dbc7-7277-9da3-4033ace48dd6",
        "storage_key": "property/5739272128692224/019d01a2-dbc7-7277-9da3-4033ace48dd6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/Moreno-Valley/CA/Moreno-Valley/92557/616?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=7077757630406817480&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "33.9429568",
      "poi_longitude": "-117.262584",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 951-242-7055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-0e65-713b-9b6d-450742e0d481.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-0e65-713b-9b6d-450742e0d481",
        "storage_key": "property/5739272128692224/019d01a3-0e65-713b-9b6d-450742e0d481.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJI23WD6yo3IARyHa1thA_OWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_151b2d96-2315-44db-984a-ecf00be5de14",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "12400 Day St, Moreno Valley, CA 92553, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store offers a good selection of products. They also highlight the store is well-organized and the staff can be helpful.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-df05-75e3-9b12-2bfd020be486.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-df05-75e3-9b12-2bfd020be486",
        "storage_key": "property/5739272128692224/019d01a2-df05-75e3-9b12-2bfd020be486.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/CA-Moreno-Valley/1574?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1574-_-na-_-0-_-0&y_source=1_MTE4NDQ4NS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=8988665617622922154&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "33.940454",
      "poi_longitude": "-117.275852",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 951-656-1859",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-0e65-713b-9b6d-450742e0d481.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-0e65-713b-9b6d-450742e0d481",
        "storage_key": "property/5739272128692224/019d01a3-0e65-713b-9b6d-450742e0d481.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJv7FkGFGv3IARqnMuV8Envnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_bdcc5254-a967-4e84-be79-b56521f50624",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "Moreno Valley College",
      "poi_type": "Education",
      "poi_address": "16130 Lasselle St, Moreno Valley, CA 92551, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-e29c-706e-8c33-274ea9ddfa16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-e29c-706e-8c33-274ea9ddfa16",
        "storage_key": "property/5739272128692224/019d01a2-e29c-706e-8c33-274ea9ddfa16.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://mvc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5019517334868949504&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "moreno-valley-college",
      "poi_latitude": "33.886786",
      "poi_longitude": "-117.2029323",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 951-571-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-0e49-7632-8cd5-c119dd212736.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-0e49-7632-8cd5-c119dd212736",
        "storage_key": "property/5739272128692224/019d01a3-0e49-7632-8cd5-c119dd212736.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJiQi-nxCn3IARAHrH6GvoqEU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d83d0d32-5c3e-408a-919b-d16f76cfd607",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "Moreno Valley Public Library",
      "poi_type": "Education",
      "poi_address": "25480 Alessandro Blvd, Moreno Valley, CA 92553, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this public library offers a wide selection of books, including textbooks and books for children, young adults, and adults of various genres. They highlight the great deals on books in the sale section, with some books being only 25 cents, and the convenient hours, open every day of the week. They also like the quiet and well-kept atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-e2a1-7467-b164-574e1e17b1a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-e2a1-7467-b164-574e1e17b1a9",
        "storage_key": "property/5739272128692224/019d01a2-e2a1-7467-b164-574e1e17b1a9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.moval.org/mv-library/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1271101610416950486&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "moreno-valley-public-library",
      "poi_latitude": "33.9175402",
      "poi_longitude": "-117.2184118",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 951-413-3880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-0e49-7632-8cd5-c119dd212736.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-0e49-7632-8cd5-c119dd212736",
        "storage_key": "property/5739272128692224/019d01a3-0e49-7632-8cd5-c119dd212736.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJs3oChrKn3IAR1kxUGi7coxE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_7ffac06d-ec6f-4384-a3e8-f3e3d802931f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "March Field Air Museum",
      "poi_type": "Entertainment",
      "poi_address": "22550 Van Buren Boulevard, Riverside, CA 92518, USA",
      "poi_short_description": "Museum with more than 70 historic military aircrafts on display including rare operational jets.",
      "poi_long_description": "People say this museum offers a vast collection of aircraft, including rare and historic planes, as well as interactive displays and exhibits showcasing aviation history. They highlight the affordable admission, the opportunity to see aircraft take off and land at the adjacent airfield, and the well-maintained facilities. They also like the friendly and knowledgeable staff and volunteers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-e43d-728b-944d-008d3da1dd24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-e43d-728b-944d-008d3da1dd24",
        "storage_key": "property/5739272128692224/019d01a2-e43d-728b-944d-008d3da1dd24.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.marchfield.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7522693662382761831&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "march-field-air-museum",
      "poi_latitude": "33.882707",
      "poi_longitude": "-117.266674",
      "poi_miles_from_property": "10.4",
      "poi_walking_minutes": "3 hours 47 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 951-902-5949",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-117d-7509-ae31-a0ca5a33ace4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-117d-7509-ae31-a0ca5a33ace4",
        "storage_key": "property/5739272128692224/019d01a3-117d-7509-ae31-a0ca5a33ace4.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8YxPByik3IARZydobAf6ZWg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_99db0cb7-3a95-46db-afbb-fa410b964b6f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "Ya'i Heki' Regional Native American Museum",
      "poi_type": "Entertainment",
      "poi_address": "17801 Lake Perris Dr, Perris, CA 92571, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-e5c5-72fb-ae83-6fb0901cd74f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-e5c5-72fb-ae83-6fb0901cd74f",
        "storage_key": "property/5739272128692224/019d01a2-e5c5-72fb-ae83-6fb0901cd74f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.parks.ca.gov/?page_id=24699",
      "poi_directions_map_url": "https://maps.google.com/?cid=12606171978923864061&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "yai-heki-regional-native-american-museum",
      "poi_latitude": "33.865502",
      "poi_longitude": "-117.1979743",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 951-940-5657",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-117d-7509-ae31-a0ca5a33ace4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-117d-7509-ae31-a0ca5a33ace4",
        "storage_key": "property/5739272128692224/019d01a3-117d-7509-ae31-a0ca5a33ace4.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJoVr8XKuh3IAR_W893Z8e8q4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_6cd26e66-8435-42fa-bc83-a48df35052b5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "San Timoteo Canyon Schoolhouse",
      "poi_type": "Entertainment",
      "poi_address": "31985 San Timoteo Canyon Rd, Redlands, CA 92373, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-e8d7-71ad-b504-f196066eabb3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-e8d7-71ad-b504-f196066eabb3",
        "storage_key": "property/5739272128692224/019d01a2-e8d7-71ad-b504-f196066eabb3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://rivcoparks.org/historic-sites-nature-centers/san-timoteo-canyon-schoolhouse",
      "poi_directions_map_url": "https://maps.google.com/?cid=10811397702385030493&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "san-timoteo-canyon-schoolhouse",
      "poi_latitude": "33.976183",
      "poi_longitude": "-117.1040922",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-234-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-119f-7095-89f7-9b834dbf4809.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-119f-7095-89f7-9b834dbf4809",
        "storage_key": "property/5739272128692224/019d01a3-119f-7095-89f7-9b834dbf4809.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK9VEa2BX24ARXVUi2O3MCZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_0d09bcde-bfe8-4aca-bbe3-af8b51d37679",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "War Dog Memorial",
      "poi_type": "Entertainment",
      "poi_address": "March Air Reserve Base, CA 92518, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-e8f9-72eb-b7da-d092ce05c4c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-e8f9-72eb-b7da-d092ce05c4c6",
        "storage_key": "property/5739272128692224/019d01a2-e8f9-72eb-b7da-d092ce05c4c6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18022417975054984098&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "war-dog-memorial",
      "poi_latitude": "33.8832304",
      "poi_longitude": "-117.2668896",
      "poi_miles_from_property": "10.4",
      "poi_walking_minutes": "3 hours 46 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-117d-7509-ae31-a0ca5a33ace4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-117d-7509-ae31-a0ca5a33ace4",
        "storage_key": "property/5739272128692224/019d01a3-117d-7509-ae31-a0ca5a33ace4.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJXxH9pq6n3IARomPEVKl9HPo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_e3167fe0-7d34-4a41-87e0-5964206b5c2a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "EōS Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "27220 Eucalyptus Ave, Moreno Valley, CA 92555, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including free weights, machines, and squat racks, as well as amenities like a pool, sauna, and outdoor workout area. They highlight the spacious layout, clean facilities, and positive, motivating atmosphere. They also like the friendly, helpful, and energetic staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-e9f5-7348-a31f-80b9236288cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-e9f5-7348-a31f-80b9236288cd",
        "storage_key": "property/5739272128692224/019d01a2-e9f5-7348-a31f-80b9236288cd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://eosfitness.com/gym/moreno-valley-ca-60-nason-st/?utm_source=local&utm_medium=organic&utm_campaign=evergreen_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=6419809013004059554&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "es-fitness",
      "poi_latitude": "33.93826120000001",
      "poi_longitude": "-117.1862319",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 909-303-9926",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-119f-7095-89f7-9b834dbf4809.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-119f-7095-89f7-9b834dbf4809",
        "storage_key": "property/5739272128692224/019d01a3-119f-7095-89f7-9b834dbf4809.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpwkAewCn3IARokP1oUi-F1k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b8cc864e-b825-419a-a7e7-8c06d779edea",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "12660 Day St, Moreno Valley, CA 92553, USA",
      "poi_short_description": "Fitness center featuring an indoor pool and a basketball court, along with a sauna.",
      "poi_long_description": "People say this gym offers a wide variety of equipment for both cardio and strength training. They also highlight the clean facilities, welcoming environment, and helpful staff.\n\nOther reviews mention the hours can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-ebcf-74ed-b662-4defbd83c4a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-ebcf-74ed-b662-4defbd83c4a9",
        "storage_key": "property/5739272128692224/019d01a2-ebcf-74ed-b662-4defbd83c4a9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/moreno-valley-ca/moreno-valley-super-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=10975493702316997884&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "33.9369522",
      "poi_longitude": "-117.275712",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 951-571-8335",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-119f-7095-89f7-9b834dbf4809.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-119f-7095-89f7-9b834dbf4809",
        "storage_key": "property/5739272128692224/019d01a3-119f-7095-89f7-9b834dbf4809.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPbeMeVev3IAR_DwkIV_JUJg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_dd7f6b48-ced0-42da-87a6-61eb4ceed433",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "12625 Frederick St, Moreno Valley, CA 92553, USA",
      "poi_short_description": "Spacious chain gym featuring free weights, workout machines, tanning and massage options.",
      "poi_long_description": "People say this gym is clean and has friendly staff. They also highlight the good value for the money and the judgement-free, drama-free atmosphere.\n\nSome reviews mention the equipment can be in need of repair.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-ee81-70b9-abc1-78d51c59bd38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-ee81-70b9-abc1-78d51c59bd38",
        "storage_key": "property/5739272128692224/019d01a2-ee81-70b9-abc1-78d51c59bd38.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/moreno-valley-ca?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=6982029411754891002&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "33.936984",
      "poi_longitude": "-117.2649215",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 951-697-8445",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-119f-7095-89f7-9b834dbf4809.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-119f-7095-89f7-9b834dbf4809",
        "storage_key": "property/5739272128692224/019d01a3-119f-7095-89f7-9b834dbf4809.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJyqa0wGm3IAR-tb68sEm5WA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_980b4291-f8b3-46d7-a289-0de22fba6369",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "27610 Eucalyptus Ave, Moreno Valley, CA 92555, USA",
      "poi_short_description": "Clean gym with a pool and a basketball court, plus cardio machines and a sauna.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-ef03-742d-b724-d967e4d0cd65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-ef03-742d-b724-d967e4d0cd65",
        "storage_key": "property/5739272128692224/019d01a2-ef03-742d-b724-d967e4d0cd65.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=977&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=13819473325084687522&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "33.9382787",
      "poi_longitude": "-117.1815367",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 951-571-8039",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-119f-7095-89f7-9b834dbf4809.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-119f-7095-89f7-9b834dbf4809",
        "storage_key": "property/5739272128692224/019d01a3-119f-7095-89f7-9b834dbf4809.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMTQfCPOn3IARoryoPMWhyL8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_12b4d7b1-1b61-49bd-b8ec-e6603d2518af",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "Euro Nails & Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "2692 Canyon Springs Pkwy, Riverside, CA 92507, USA",
      "poi_short_description": "Nail salon providing gel manicures and pedicures, plus hot stone massages.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-f10d-749b-bfff-7ecb71c08cfb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-f10d-749b-bfff-7ecb71c08cfb",
        "storage_key": "property/5739272128692224/019d01a2-f10d-749b-bfff-7ecb71c08cfb.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "http://euronailspariverside.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4029356480065985196&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "euro-nails--spa",
      "poi_latitude": "33.9414588",
      "poi_longitude": "-117.2825322",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 951-656-5888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-119f-7095-89f7-9b834dbf4809.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-119f-7095-89f7-9b834dbf4809",
        "storage_key": "property/5739272128692224/019d01a3-119f-7095-89f7-9b834dbf4809.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdyHn3lqv3IARrFrAw14m6zc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_ab31e748-320f-46aa-b9cf-c981942f043c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "Crunch Fitness - Moreno Valley",
      "poi_type": "Health and Wellness",
      "poi_address": "22500 Town Cir, Moreno Valley, CA 92553, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-f3b3-7680-a931-b3f80d1074c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-f3b3-7680-a931-b3f80d1074c1",
        "storage_key": "property/5739272128692224/019d01a2-f3b3-7680-a931-b3f80d1074c1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.crunch.com/locations/moreno-valley",
      "poi_directions_map_url": "https://maps.google.com/?cid=18370536040440391502&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---moreno-valley",
      "poi_latitude": "33.9388636",
      "poi_longitude": "-117.2701835",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 951-616-1002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-119f-7095-89f7-9b834dbf4809.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-119f-7095-89f7-9b834dbf4809",
        "storage_key": "property/5739272128692224/019d01a3-119f-7095-89f7-9b834dbf4809.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWR87TFSv3IARTuf1jzJB8f4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1d03b4f8-6a55-40a5-8aaf-6026889f6973",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "Realis Gymnastics Academy",
      "poi_type": "Health and Wellness",
      "poi_address": "12125 Day St, Moreno Valley, CA 92557, USA",
      "poi_short_description": "Gym for kids (ages 2-18), offering competitive and recreational classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-f3f1-752d-9d27-ad8f7728d5ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-f3f1-752d-9d27-ad8f7728d5ca",
        "storage_key": "property/5739272128692224/019d01a2-f3f1-752d-9d27-ad8f7728d5ca.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.realisgymnastics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12573816372025855245&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "realis-gymnastics-academy",
      "poi_latitude": "33.9452217",
      "poi_longitude": "-117.2832183",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 951-686-4101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-0e49-7632-8cd5-c119dd212736.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-0e49-7632-8cd5-c119dd212736",
        "storage_key": "property/5739272128692224/019d01a3-0e49-7632-8cd5-c119dd212736.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ31aWpEWv3IARDY2XFV8rf64",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4e873893-acd6-4676-8a5d-3fdd935e49be",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "Alessandro Animal Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "23932 Alessandro Blvd # B, Moreno Valley, CA 92553, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-f416-768f-bb7a-f9e3fbb0c2b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-f416-768f-bb7a-f9e3fbb0c2b2",
        "storage_key": "property/5739272128692224/019d01a2-f416-768f-bb7a-f9e3fbb0c2b2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://alessandroanimalhospital.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3587016359071956374&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "alessandro-animal-hospital",
      "poi_latitude": "33.9180842",
      "poi_longitude": "-117.2453421",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 951-656-4455",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-119f-7095-89f7-9b834dbf4809.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-119f-7095-89f7-9b834dbf4809",
        "storage_key": "property/5739272128692224/019d01a3-119f-7095-89f7-9b834dbf4809.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfdC_Cmum3IARlr3_rV-kxzE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_3ae73928-ba23-4879-a7e2-f0258b998ab3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "GOAT Barbershop",
      "poi_type": "Health and Wellness",
      "poi_address": "12190 Perris Blvd SUITE G-H, Moreno Valley, CA 92557, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-f5bd-707a-b955-953b3195cd41.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-f5bd-707a-b955-953b3195cd41",
        "storage_key": "property/5739272128692224/019d01a2-f5bd-707a-b955-953b3195cd41.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://goatbarbershop.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3250993337785777026&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "goat-barbershop",
      "poi_latitude": "33.9444133",
      "poi_longitude": "-117.2255808",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 951-214-2497",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-119f-7095-89f7-9b834dbf4809.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-119f-7095-89f7-9b834dbf4809",
        "storage_key": "property/5739272128692224/019d01a3-119f-7095-89f7-9b834dbf4809.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF97zH6mn3IARgvvhWTfZHS0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_79eb4a40-ccd3-472e-936a-c755a33353d8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "Riverside University Health System Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "26520 Cactus Ave, Moreno Valley, CA 92555, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-f934-7716-a080-8e67b1d2a258.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-f934-7716-a080-8e67b1d2a258",
        "storage_key": "property/5739272128692224/019d01a2-f934-7716-a080-8e67b1d2a258.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.ruhealth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13130308091680572376&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "riverside-university-health-system-medical-center",
      "poi_latitude": "33.91215650000001",
      "poi_longitude": "-117.1960001",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 951-486-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-119f-7095-89f7-969d0fa5b33d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-119f-7095-89f7-969d0fa5b33d",
        "storage_key": "property/5739272128692224/019d01a3-119f-7095-89f7-969d0fa5b33d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4-Om45-n3IAR2MMOXKQ5OLY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_bcd25cc3-0fe1-4d94-99cc-beefdc6ab548",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "Kaiser Permanente Moreno Valley Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "27300 Iris Ave, Moreno Valley, CA 92555, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-f947-7633-aa05-6d100ab411fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-f947-7633-aa05-6d100ab411fd",
        "storage_key": "property/5739272128692224/019d01a2-f947-7633-aa05-6d100ab411fd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://healthy.kaiserpermanente.org/southern-california/facilities/Moreno-Valley-Medical-Center-300019",
      "poi_directions_map_url": "https://maps.google.com/?cid=15010169944161353901&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kaiser-permanente-moreno-valley-medical-center",
      "poi_latitude": "33.896939",
      "poi_longitude": "-117.1858619",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 833-574-2273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-119f-7095-89f7-969d0fa5b33d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-119f-7095-89f7-969d0fa5b33d",
        "storage_key": "property/5739272128692224/019d01a3-119f-7095-89f7-969d0fa5b33d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_X9hiGin3IARrYD7cwnWTtA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_c5ab888d-c7eb-41ab-9c2a-1c1dac179d3d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "Lake Perris State Recreation Area",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Lake Perris Drive, Perris, CA 92571, USA",
      "poi_short_description": "Reserve on a lake, popular for boating & hikes in rocky terrain home to bobcats & birdlife.",
      "poi_long_description": "People say this state park offers a beautiful lake for swimming, boating, jet skiing, and fishing, as well as hiking trails, picnic areas, and camping. They highlight the convenient location, spacious grounds, and family-friendly atmosphere, with opportunities for outdoor recreation and relaxation. They also like the clean facilities and the presence of lifeguards during the summer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-f98a-767c-9969-d49ad37cabdc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-f98a-767c-9969-d49ad37cabdc",
        "storage_key": "property/5739272128692224/019d01a2-f98a-767c-9969-d49ad37cabdc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.parks.ca.gov/lakeperris/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5993210985787647134&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lake-perris-state-recreation-area",
      "poi_latitude": "33.8685628",
      "poi_longitude": "-117.1766137",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 951-940-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-11bc-73ef-aec1-65d73a01c944.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-11bc-73ef-aec1-65d73a01c944",
        "storage_key": "property/5739272128692224/019d01a3-11bc-73ef-aec1-65d73a01c944.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5Uoodqug3IARnmTXX6MpLFM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_86f191f8-133a-43a6-ab10-cc5ca437623f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "Moreno Valley Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13380 Frederick St, Moreno Valley, CA 92553, USA",
      "poi_short_description": "Soccer fields & a playground, plus a picnic area with tables, BBQ grills & a snack bar.",
      "poi_long_description": "People say this park offers a skate park, soccer fields, and tables with grills. They also highlight the spacious layout, ample parking, and shade provided by trees.\n\nOther reviews mention the restrooms can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-fa53-775a-a70b-7fc5ae813de0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-fa53-775a-a70b-7fc5ae813de0",
        "storage_key": "property/5739272128692224/019d01a2-fa53-775a-a70b-7fc5ae813de0.webp",
        "width": 1280,
        "height": 762
      },
      "poi_business_url": "http://www.moreno-valley.ca.us/resident_services/park_rec/index_park-rec.shtml",
      "poi_directions_map_url": "https://maps.google.com/?cid=9693648778231650313&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "moreno-valley-community-park",
      "poi_latitude": "33.9264129",
      "poi_longitude": "-117.2600245",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 951-413-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-11bc-73ef-aec1-65d73a01c944.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-11bc-73ef-aec1-65d73a01c944",
        "storage_key": "property/5739272128692224/019d01a3-11bc-73ef-aec1-65d73a01c944.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJR2RPag-m3IARCZjlYzTChoY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_de0e8d8d-f9a2-4568-a32b-28852387b96a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "Rancho del Sol Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "28095 John F Kennedy Dr, Moreno Valley, CA 92555, USA",
      "poi_short_description": "Golf course with a challenging layout and fast greens, set in a hilly area with scenic views.",
      "poi_long_description": "People say this golf course has a great layout with challenging holes and amazing views, especially on the back nine. They also highlight the good value, especially the senior rate, and the friendly staff.\n\nOther reviews mention there can be no driving range.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-0007-702c-8421-575195c443b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a3-0007-702c-8421-575195c443b1",
        "storage_key": "property/5739272128692224/019d01a3-0007-702c-8421-575195c443b1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ranchodelsolgolfclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13371108337076520165&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rancho-del-sol-golf-club",
      "poi_latitude": "33.9023405",
      "poi_longitude": "-117.1713889",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 951-455-4545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-14b3-778e-8beb-e2b940c3ee57.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-14b3-778e-8beb-e2b940c3ee57",
        "storage_key": "property/5739272128692224/019d01a3-14b3-778e-8beb-e2b940c3ee57.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJMYyOp_yn3IAR5cS1fDC4j7k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_beceedbd-9e08-4ddc-89ea-fd36418df29a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "Shadow Mountain Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "23680 Presidio Hills Dr, Moreno Valley, CA 92557, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this park offers a playground, zip lines, and open fields for sports. They highlight the park is clean, well-maintained, and safe, and the zip lines are fun for children. They also like the spacious layout, shaded areas, and picnic facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-ffad-75c0-b7f9-b1ce64e7958e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-ffad-75c0-b7f9-b1ce64e7958e",
        "storage_key": "property/5739272128692224/019d01a2-ffad-75c0-b7f9-b1ce64e7958e.webp",
        "width": 768,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10004771663531356722&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "shadow-mountain-park",
      "poi_latitude": "33.9786015",
      "poi_longitude": "-117.2576912",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 951-413-3280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-11bc-73ef-aec1-65d73a01c944.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-11bc-73ef-aec1-65d73a01c944",
        "storage_key": "property/5739272128692224/019d01a3-11bc-73ef-aec1-65d73a01c944.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2dOJwdeo3IARMjKuB9IW2Io",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_262c01a5-04dc-482a-84fd-6005e08a393b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "Celebration Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "14965 Morgan Ave, Moreno Valley, CA 92555, USA",
      "poi_short_description": "Well-maintained park, also home to a splash area where kids can run around and get wet.",
      "poi_long_description": "People say this park offers a water area, playground, and basketball court, and is a great place for kids to play. They highlight the clean facilities, including restrooms and picnic areas, and the spacious layout with plenty of shade trees and grassy areas. They also like the helpful and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-01e9-739e-aaaf-8e49da8d9d15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a3-01e9-739e-aaaf-8e49da8d9d15",
        "storage_key": "property/5739272128692224/019d01a3-01e9-739e-aaaf-8e49da8d9d15.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7285428851894213825&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "celebration-park",
      "poi_latitude": "33.9035024",
      "poi_longitude": "-117.1816909",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-11bc-73ef-aec1-65d73a01c944.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-11bc-73ef-aec1-65d73a01c944",
        "storage_key": "property/5739272128692224/019d01a3-11bc-73ef-aec1-65d73a01c944.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJA9te3WSn3IARwVyJ4fAKG2U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f8baa7fb-26ca-479c-9653-8bb319d93adf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "March ARB Visitor Control Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "363 Graeber St, March Air Reserve Base, CA 92518, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-01e9-739e-aaaf-90f6e600c03f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a3-01e9-739e-aaaf-90f6e600c03f",
        "storage_key": "property/5739272128692224/019d01a3-01e9-739e-aaaf-90f6e600c03f.webp",
        "width": 1280,
        "height": 822
      },
      "poi_business_url": "https://www.march.afrc.af.mil/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5383787358161936805&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "march-arb-visitor-control-center",
      "poi_latitude": "33.9093976",
      "poi_longitude": "-117.2714862",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 951-655-3791",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-119f-7095-89f7-9b834dbf4809.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-119f-7095-89f7-9b834dbf4809",
        "storage_key": "property/5739272128692224/019d01a3-119f-7095-89f7-9b834dbf4809.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVUN1zd6l3IARpSF75RMOt0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_5ecacd20-8ea4-4876-933d-016cd7ee1565",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "Moreno Valley City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "14177 Frederick St, Moreno Valley, CA 92553, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-0822-71fe-86f5-7063162427b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a3-0822-71fe-86f5-7063162427b7",
        "storage_key": "property/5739272128692224/019d01a3-0822-71fe-86f5-7063162427b7.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "http://www.moval.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16438204615921959500&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "moreno-valley-city-hall",
      "poi_latitude": "33.9148134",
      "poi_longitude": "-117.2616433",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 951-413-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-14a9-706a-af48-9452f34b63d3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-14a9-706a-af48-9452f34b63d3",
        "storage_key": "property/5739272128692224/019d01a3-14a9-706a-af48-9452f34b63d3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdYWje3Om3IARTAI3PQE8IOQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_c253c7bc-e7ff-4144-aaec-db8d5549b360",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "ID Office, March ARB",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1351 Graeber St, March Air Reserve Base, CA 92518, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-092b-7248-ac4c-797947ce1711.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a3-092b-7248-ac4c-797947ce1711",
        "storage_key": "property/5739272128692224/019d01a3-092b-7248-ac4c-797947ce1711.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.march.afrc.af.mil/Contact-Us/Questions/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4213828598205058450&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "id-office-march-arb",
      "poi_latitude": "33.9053732",
      "poi_longitude": "-117.2678453",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 951-655-3028",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-119f-7095-89f7-9b834dbf4809.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-119f-7095-89f7-9b834dbf4809",
        "storage_key": "property/5739272128692224/019d01a3-119f-7095-89f7-9b834dbf4809.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJbHwBtil3IARkg1lxMiGejo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_9b32d314-d2d6-4c50-9f2e-5f41d432087b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "Socal Supermoto",
      "poi_type": "Major Employers & Offices",
      "poi_address": "18700 Lake Perris Dr, Perris, CA 92571, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-094f-724c-8b9e-8f6f9161b5e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a3-094f-724c-8b9e-8f6f9161b5e0",
        "storage_key": "property/5739272128692224/019d01a3-094f-724c-8b9e-8f6f9161b5e0.webp",
        "width": 1280,
        "height": 772
      },
      "poi_business_url": "http://socalsupermoto.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4180796395133427745&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "socal-supermoto",
      "poi_latitude": "33.855368",
      "poi_longitude": "-117.2030224",
      "poi_miles_from_property": "10.5",
      "poi_walking_minutes": "3 hours 44 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "39 mins",
      "poi_business_phone": "+1 619-224-6686",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-119f-7095-89f7-9b834dbf4809.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-119f-7095-89f7-9b834dbf4809",
        "storage_key": "property/5739272128692224/019d01a3-119f-7095-89f7-9b834dbf4809.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm15jDhWy3IARIWApqissBTo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_bd7a80d8-7166-4cc9-8c74-e332e71536fa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "Penske Logistics",
      "poi_type": "Major Employers & Offices",
      "poi_address": "278 W Markham St, Perris, CA 92571, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-0984-77bf-8158-857669b99330.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a3-0984-77bf-8158-857669b99330",
        "storage_key": "property/5739272128692224/019d01a3-0984-77bf-8158-857669b99330.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7337404163491145961&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "penske-logistics",
      "poi_latitude": "33.85232630000001",
      "poi_longitude": "-117.2208431",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-119f-7095-89f7-9b834dbf4809.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-119f-7095-89f7-9b834dbf4809",
        "storage_key": "property/5739272128692224/019d01a3-119f-7095-89f7-9b834dbf4809.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP8hlkCeh3IAR6ahcIjay02U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_cbfe6192-ce80-43a6-9c92-a04037a84e06",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "custom",
      "poi_name": "Sky Zone Trampoline Park",
      "poi_type": "Entertainment",
      "poi_address": "22550 Town Cir, Moreno Valley, CA 92553, USA",
      "poi_short_description": "Chain of indoor trampoline parks featuring freestyle bouncing, dodgeball, fitness programs & more.",
      "poi_long_description": "Chain of indoor trampoline parks featuring freestyle bouncing, dodgeball, fitness programs & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019e041f-ba7c-73a0-90b4-71d919f26a31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e041f-ba7c-73a0-90b4-71d919f26a31",
        "storage_key": "property/5739272128692224/019e041f-ba7c-73a0-90b4-71d919f26a31.webp",
        "width": 228,
        "height": 160
      },
      "poi_business_url": "https://www.skyzone.com/moreno-valley-ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7744140354548553552&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sky-zone-trampoline-park",
      "poi_latitude": "33.9378665",
      "poi_longitude": "-117.2696324",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 951-582-2139",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-119f-7095-89f7-9b834dbf4809.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a3-119f-7095-89f7-9b834dbf4809",
        "storage_key": "property/5739272128692224/019d01a3-119f-7095-89f7-9b834dbf4809.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQYwYfHyv3IARUFeiS5-2eGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    }
  ],
  "office_hours": [
    {
      "id": "custom_bb3bb7cb-acf1-4afc-b5d0-3d758871028d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "day": "WED",
      "open_time": "11:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_f293eb93-635e-4974-bfa9-c1ad2272a314",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_2b46c892-ed46-49c6-a23a-0e1a7c8f82cb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_9f3fac6e-a932-4d03-aa77-a4de62e50bcd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_61ab9a76-e3e2-4f00-a11c-2861ae2289e1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_bb3e33ead74d0f6a274de313",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "rating": "4",
      "name": "false",
      "text": "I have been living here for 4yrs, the complex has a lot of great amenities; washer, dryer, dishwasher, gym, movie theater, very nice pool with BBQ, and a billiard center. The apartment comes with basic cable which is just fine since I'm hardly ever home. The balcony is big enough for a full outdoor table set. Walking distance from a lot of shopping centers. The only bad thing is parking. There is hardly any guest parking or if you have two cars. They recently have actually shorten the amount of guest parking by putting up reserve parking signs which are usually vacant. A lot have changed since the new management good and bad. Some of the staff are nice, I haven't had any problems personally just what my neighbors have said. Overall I love these apartments and will probably renew my lease.",
      "date": "false",
      "title": "Nice, Clean, Affortable"
    },
    {
      "id": "ec_258a80bed2963e5c8989b11b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "rating": "5",
      "name": "false",
      "text": "I have been a resident here at the Rancho Belago Apartments in Moreno Valley since 2/2015. These apartments are by far the best apartments I have lived in and I have lived in a couple different one's. They have a nice big resort like swimming pool with a jacuzzi and also have three showers that you can wash yourself off before and after you treat yourself to a nice swim or a relaxing day in the jacuzzi. They also have two gas bbq's to make your favorite meats of coice ! For all the people who want to get a good workout they also have a nice size gym with a good selection of machines to pick from to get your workout on. They have two restrooms conveniently located out by the pool so you can use instead of having to walk back to your apartment so you can get back to enjoying your day out by the pool. For those family nights they also have a nice movie theater that you can reserve so you can bring your favorite dvd movie to and enjoy watching a movie with the family. They have a computer room with two computers to use and also a conference room to use for those important meetings. There is a clubhouse that has a nice size tv to watch the games on and a pool table to play a couple games of pool. If you like the out doors they have a nice trail you can jog behind the apartments with some good mountain views. They have 1,2 and 3 bedroom apartments to choose from some that come with a garage or a car port. It is a gated community that you will need a special key so only residents can get in. It is conveniently located next to a super walmart super center  and also a target super center with lots of other restaurants and stores to pick frome and close to the 60 fwy. You should stop on by and check it out, you might be the next future resident who will be writing a good review on how much you love living here at the Rancho Belago Apartments !",
      "date": "false",
      "title": "Rancho Belago Apartments in Moreno Valley, CA"
    },
    {
      "id": "ec_966df046f507e31c46aa9189",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "rating": "4",
      "name": "false",
      "text": "This place is like a resort not any apartment complex I have ever lived in. The amenities are amazing, the staff is so helpful and kind, and they are very attentive to maintenance issues that arise. Parking can be an issue with visitors, but there are plenty of spaces available just not always in front of your location. The appliances seem the same age as the complex but are in good working condition. Overall, this is a big improvement over some places I have lived in the past.",
      "date": "false",
      "title": "Resort Living"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_436a9d0181f8406dfd105078",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-3fce-745b-977f-cf9784e69111.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Interior view of a living and dining area with a kitchen counter and dining table.",
        "public_id": "019d01a3-3fce-745b-977f-cf9784e69111",
        "storage_key": "property/5739272128692224/019d01a3-3fce-745b-977f-cf9784e69111.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "1BR, 1BA - Santa Barbara",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=5NTtgK76SkA"
    },
    {
      "id": "ec_811974469d385961a89a1095",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a3-3fbb-727f-83e5-fd38d65287a5.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen with granite countertops, stainless steel sink, black appliances, and white cabinets.",
        "public_id": "019d01a3-3fbb-727f-83e5-fd38d65287a5",
        "storage_key": "property/5739272128692224/019d01a3-3fbb-727f-83e5-fd38d65287a5.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "2BR, 2BA - Catalina",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=nxDgnnrdLM1"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa47-5078-747e-b61a-eb6243072d2b",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rancho-belago",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224"
    },
    {
      "lead_collector_id": "0198aa47-50da-703f-aa7e-8cae055e9400",
      "lead_source": "FACEBOOK_ADS",
      "name": "rancho-belago",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224"
    },
    {
      "lead_collector_id": "0198aa47-513e-714b-9d0f-d4e80059a004",
      "lead_source": "LANDING_PAGE",
      "name": "rancho-belago",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "generator",
      "page_item_url": "pool-apartments-in-moreno-valley-east",
      "search_query": "pool apartments in Moreno Valley East",
      "category": "Amenity",
      "h1_title": "Pool Apartments in Moreno Valley East",
      "h2_subtitle": "Explore our poolside living experience in Moreno Valley East. Enjoy luxurious amenities and vibrant community spaces at Rancho Belago.",
      "page_copy": "Finding the perfect pool apartment in Moreno Valley East is easy at Rancho Belago. Our community offers beautifully designed one, two, and three-bedroom floor plans that provide comfort and style. Residents can enjoy a refreshing dip in our sparkling pool, gather with friends at the clubhouse, or unwind after a long day. With a fully equipped fitness center and nearby walking/biking trails, it's not just about relaxing—it's about leading a balanced lifestyle. Experience true comfort and convenience at Rancho Belago.\n\nAt Rancho Belago, our vibrant community stands out with a range of top-tier amenities. From crown molding in the living spaces to granite countertops in the kitchens, every detail is curated for your ultimate satisfaction. Whether you're exploring the dynamic resident lounge or savoring a meal in the dining room, you'll find plenty of opportunities to relax and socialize. Dive into a perfect blend of luxury and location, where pool apartments in Moreno Valley East offer an unmatched living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a double sink.",
        "public_id": "019d01a2-a4d0-700e-9c5d-639e8431d980",
        "storage_key": "property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxurious Pool Apartments in Moreno Valley East",
      "seo_description": "Discover Rancho Belago's pool apartments in Moreno Valley East with luxurious amenities and community features tailored for modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-moreno-valley-ca",
      "search_query": "in unit laundry apartments Moreno Valley CA",
      "category": "Amenity",
      "h1_title": "In Unit Laundry Apartments in Moreno Valley CA",
      "h2_subtitle": "Experience the convenience of in-unit laundry at Rancho Belago. Located in Moreno Valley, CA, we bring comfort and ease to everyday living.",
      "page_copy": "Rancho Belago in Moreno Valley, CA offers apartments with essential modern conveniences, including in-unit laundry. Our thoughtfully designed one, two, and three-bedroom floor plans help simplify daily living, allowing you more time to enjoy our other fabulous amenities. Whether you're relaxing at the on-site gym or hosting a barbecue by the grill, you'll find living here is both convenient and enjoyable.\n\nPerfectly situated in the heart of Moreno Valley, Rancho Belago combines luxury and practicality. Beyond the ease of in-unit laundry, residents appreciate features like crown molding, granite countertops, and resident-focused spaces such as the clubhouse. Whether you're ready to explore the nearby hiking trails or participate in planned social activities, our community is an ideal place to call home. Enjoy the best of apartment living with the added benefit of in-unit laundry right at your fingertips.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a double sink.",
        "public_id": "019d01a2-a4d0-700e-9c5d-639e8431d980",
        "storage_key": "property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In Unit Laundry Apartments in Moreno Valley, CA",
      "seo_description": "Find convenient in-unit laundry apartments at Rancho Belago, Moreno Valley CA. Experience modern living at its best with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-in-92555",
      "search_query": "air conditioned apartments in 92555",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in 92555",
      "h2_subtitle": "Stay cool in air conditioned comfort at Rancho Belago. Our apartments in 92555 offer modern amenities for a perfect lifestyle.",
      "page_copy": "Rancho Belago in the 92555 area offers air conditioned apartments that ensure you stay comfortable no matter the season. Choose from our range of one, two, or three-bedroom homes, each equipped with modern features designed to enhance your living experience. Beat the heat while enjoying the luxurious details like granite countertops and crown molding.\n\nOur community in Moreno Valley is designed with comfort in mind, offering more than just air-conditioned spaces. Residents can relax in the vibrant lounge, dine at the grill area, or stay active on the walking and biking trails. With a fully-equipped fitness center and planned social activities, Rancho Belago provides everything you need to live well. Experience the perfect blend of convenience and style in our air conditioned apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a double sink.",
        "public_id": "019d01a2-a4d0-700e-9c5d-639e8431d980",
        "storage_key": "property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in 92555",
      "seo_description": "Discover air conditioned apartments at Rancho Belago in 92555. Enjoy cool comfort and modern amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "generator",
      "page_item_url": "apartments-with-fitness-center-moreno-valley",
      "search_query": "apartments with fitness center Moreno Valley",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in Moreno Valley",
      "h2_subtitle": "Enhance your lifestyle with our fitness center-equipped apartments. Rancho Belago offers exceptional living in Moreno Valley.",
      "page_copy": "Discover the perfect blend of fitness and luxury living at Rancho Belago in Moreno Valley. Our community offers residents access to a state-of-the-art fitness center, ensuring you have all the tools you need to stay active and healthy right at home. Choose from beautifully appointed one, two, or three-bedroom apartments, each designed with your comfort in mind.\n\nIn addition to our fitness center, Rancho Belago boasts a range of amenities designed to enrich your lifestyle, including a vibrant resident lounge, outdoor grill, and scenic walking and biking trails. Located in the heart of Moreno Valley, you'll find planned social activities that encourage community and connection. Experience the best in fitness and apartment living at Rancho Belago.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a double sink.",
        "public_id": "019d01a2-a4d0-700e-9c5d-639e8431d980",
        "storage_key": "property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center in Moreno Valley",
      "seo_description": "Enjoy living in an apartment with a fitness center at Rancho Belago, Moreno Valley. Fitness and luxury living go hand in hand here.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "generator",
      "page_item_url": "rancho-belago-granite-countertop-apartments",
      "search_query": "Rancho Belago granite countertop apartments",
      "category": "Amenity",
      "h1_title": "Rancho Belago Granite Countertop Apartments",
      "h2_subtitle": "Experience elegance with granite countertop apartments at Rancho Belago. Enjoy upscale living in the heart of Moreno Valley.",
      "page_copy": "At Rancho Belago, our granite countertop apartments redefine elegance in Moreno Valley. Each one, two, and three-bedroom apartment is thoughtfully designed with style and functionality in mind, featuring stunning granite countertops that elevate your cooking and dining experience. Enhance your daily routine with these luxurious and durable finishes that speak to superior craftsmanship and attention to detail.\n\nRancho Belago isn’t just about remarkable interiors; it’s a community equipped with exceptional amenities. From the welcoming clubhouse and outdoor grill area to the scenic walking trails and upscale fitness center, we ensure there’s something for everyone. And with a lively social calendar, residents have endless opportunities to connect and create lasting memories. Discover elevated living at Rancho Belago today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a double sink.",
        "public_id": "019d01a2-a4d0-700e-9c5d-639e8431d980",
        "storage_key": "property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rancho Belago Granite Countertop Apartments",
      "seo_description": "Discover granite countertop apartments at Rancho Belago. Experience stylish, upscale living in Moreno Valley with exceptional amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-moreno-valley",
      "search_query": "one bedroom apartments moreno valley",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Moreno Valley",
      "h2_subtitle": "Explore our cozy one bedroom apartments at Rancho Belago. Perfectly located in Moreno Valley, they offer comfort and modern style.",
      "page_copy": "Experience the perfect blend of comfort and style in our one bedroom apartments at Rancho Belago, centrally located in Moreno Valley. These thoughtfully designed spaces feature high-end amenities, including granite countertops and elegant crown molding, creating an inviting atmosphere that you'll love coming home to every day.\n\nBeyond the individual living spaces, Rancho Belago offers a vibrant community packed with amenities to enhance your lifestyle. Enjoy winding down in our stylish clubhouse, challenging yourself in the fitness center, or taking in the scenic beauty along our walking and biking trails. Plus, our active social calendar is perfect for meeting new friends and making memories in a community that feels like home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a double sink.",
        "public_id": "019d01a2-a4d0-700e-9c5d-639e8431d980",
        "storage_key": "property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Moreno Valley",
      "seo_description": "Find the perfect one bedroom apartment at Rancho Belago in Moreno Valley. Modern design and upscale amenities await you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-moreno-valley-east",
      "search_query": "two bedroom apartments moreno valley east",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Moreno Valley East",
      "h2_subtitle": "Discover comfy two bedroom apartments at Rancho Belago, nestled in Moreno Valley East for modern living and convenience.",
      "page_copy": "Rancho Belago invites you to explore our spacious two bedroom apartments, perfectly situated in the popular Moreno Valley East neighborhood. These apartments offer stylish interiors with modern design elements like granite countertops, providing both functionality and elegance. Whether you're a growing family or need extra space for a home office, our two bedroom options cater to diverse lifestyles.\n\nEnjoy more than just a beautiful apartment at Rancho Belago with community features that include a welcoming clubhouse, state-of-the-art fitness center, and scenic walking and biking trails. Located in the heart of Moreno Valley East, you'll find yourself at the center of a community that blends urban convenience with a tranquil residential setting. Make Rancho Belago your new home today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a double sink.",
        "public_id": "019d01a2-a4d0-700e-9c5d-639e8431d980",
        "storage_key": "property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Moreno Valley East",
      "seo_description": "Explore two bedroom apartments at Rancho Belago in Moreno Valley East. Enjoy modern interiors and community amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-92555",
      "search_query": "three bedroom apartments 92555",
      "category": "Floorplan",
      "h1_title": "Spacious Three Bedroom Apartments in 92555",
      "h2_subtitle": "Discover spacious three bedroom apartments in the 92555 area at Rancho Belago. Perfect for families seeking comfort and style.",
      "page_copy": "Make Rancho Belago your home with our expansive three bedroom apartments located in the vibrant 92555 area. Designed with families and those needing extra space in mind, these apartments feature generous layouts, complete with upscale finishes like granite countertops. You'll find ample room for entertaining or relaxing, making every day a delightful experience.\n\nBeyond the luxurious interiors, Rancho Belago provides a range of options to enrich your living experience. From our well-equipped fitness center and inviting clubhouse to leisurely walks along the community’s scenic trails, every amenity is here to complement your lifestyle. Nestled in the heart of the 92555 area, Rancho Belago offers a serene yet convenient location, making it the ideal space for harmonious living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a double sink.",
        "public_id": "019d01a2-a4d0-700e-9c5d-639e8431d980",
        "storage_key": "property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in 92555",
      "seo_description": "Discover three bedroom apartments at Rancho Belago in the 92555 area. Perfect for families, offering modern amenities and ample space.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "generator",
      "page_item_url": "apartments-near-moreno-valley-college-ca",
      "search_query": "apartments near moreno valley college ca",
      "category": "School",
      "h1_title": "Apartments Near Moreno Valley College, CA",
      "h2_subtitle": "Find convenient apartments near Moreno Valley College, CA. Rancho Belago offers modern living just minutes from campus.",
      "page_copy": "Located just a short drive from Moreno Valley College, Rancho Belago offers the perfect apartment options for students and staff seeking a modern and comfortable living environment. Our community provides a selection of one, two, or three-bedroom floor plans, each designed with stylish interiors such as granite countertops and crown molding, ensuring a contemporary feel.\n\nRancho Belago's amenities enhance your lifestyle with features like a vibrant resident lounge and a fitness center, perfect for relaxing or staying active. Enjoy the convenience of living close to campus while benefiting from scenic walking and biking trails, promoting a balanced lifestyle. Make Rancho Belago your home and enjoy seamless access to education and all that Moreno Valley, CA has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a double sink.",
        "public_id": "019d01a2-a4d0-700e-9c5d-639e8431d980",
        "storage_key": "property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Moreno Valley College, CA",
      "seo_description": "Discover nearby apartments at Rancho Belago, conveniently close to Moreno Valley College, CA. Experience modern living with easy campus access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "generator",
      "page_item_url": "uc-riverside-nearby-apartments-moreno-valley",
      "search_query": "uc riverside nearby apartments moreno valley",
      "category": "School",
      "h1_title": "UC Riverside Nearby Apartments in Moreno Valley",
      "h2_subtitle": "Explore nearby apartments in Moreno Valley ideal for UC Riverside students. Live in comfort at Rancho Belago.",
      "page_copy": "Rancho Belago provides ideal living options for those studying or working at UC Riverside, offering nearby apartments with modern amenities in the heart of Moreno Valley. Our one, two, and three-bedroom floor plans are designed with contemporary finishes, such as granite countertops and crown molding, ensuring a comfortable and stylish home environment.\n\nResidents of Rancho Belago enjoy an array of amenities, including a lively clubhouse and a fitness center, perfect for unwinding after a busy day on campus. Plus, our walking and biking trails offer a perfect escape into nature. Situated just a short drive from UC Riverside, our location provides the perfect blend of convenience and tranquility, making it an excellent choice for students and staff seeking a serene place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a double sink.",
        "public_id": "019d01a2-a4d0-700e-9c5d-639e8431d980",
        "storage_key": "property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "UC Riverside Nearby Apartments in Moreno Valley",
      "seo_description": "Discover nearby apartments at Rancho Belago, ideal for UC Riverside students. Enjoy modern amenities and a prime Moreno Valley location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "generator",
      "page_item_url": "apartments-close-to-university-of-redlands-92555",
      "search_query": "apartments close to university of redlands 92555",
      "category": "School",
      "h1_title": "Apartments Close to University of Redlands 92555",
      "h2_subtitle": "Find your perfect home near University of Redlands in the 92555 area. Enjoy modern living at Rancho Belago.",
      "page_copy": "Rancho Belago offers an ideal living solution for those seeking apartments close to the University of Redlands in the 92555 area. Choose from our range of thoughtfully designed one, two, or three-bedroom floor plans, featuring stylish interiors like granite countertops to suit your lifestyle needs. Located conveniently, Rancho Belago offers a peaceful residential setting just a short drive from campus.\n\nOur community amenities enhance your living experience with features such as a welcoming clubhouse and a state-of-the-art fitness center. For those who enjoy the outdoors, our scenic walking and biking trails offer a refreshing escape. Experience the perfect balance of comfort and accessibility by making Rancho Belago your new home, placing you near academic pursuits at the University of Redlands while enjoying a modern and serene living space.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a double sink.",
        "public_id": "019d01a2-a4d0-700e-9c5d-639e8431d980",
        "storage_key": "property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to University of Redlands 92555",
      "seo_description": "Discover convenient apartments near University of Redlands in the 92555 area. Experience modern amenities and comfort at Rancho Belago.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "generator",
      "page_item_url": "housing-options-near-loma-linda-university-moreno-valley",
      "search_query": "housing options near loma linda university moreno valley",
      "category": "School",
      "h1_title": "Housing Near Loma Linda University, Moreno Valley",
      "h2_subtitle": "Explore housing options near Loma Linda University in Moreno Valley. Rancho Belago offers a range of modern living spaces.",
      "page_copy": "For those seeking housing options near Loma Linda University in Moreno Valley, Rancho Belago delivers a perfect blend of comfort and convenience. Our selection of one, two, or three-bedroom apartments is designed with modern touches, including granite countertops, offering a cozy and contemporary lifestyle.\n\nJust a short commute from Loma Linda University, Rancho Belago provides easy access to both your academic commitments and relaxation. Our robust amenities, like a resident clubhouse and fitness center, cater to varied lifestyles. Embrace outdoor living with our walking and biking trails, where you can unwind and enjoy the surroundings. Choose Rancho Belago for a harmonious balance of work and leisure, right here in Moreno Valley.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a double sink.",
        "public_id": "019d01a2-a4d0-700e-9c5d-639e8431d980",
        "storage_key": "property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Housing Near Loma Linda University, Moreno Valley",
      "seo_description": "Find modern housing options near Loma Linda University in Moreno Valley. Explore Rancho Belago's stylish apartments and vibrant community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "generator",
      "page_item_url": "apartments-by-highland-elementary-moreno-valley-east",
      "search_query": "apartments by highland elementary moreno valley east",
      "category": "School",
      "h1_title": "Apartments by Highland Elementary, Moreno Valley East",
      "h2_subtitle": "Discover family-friendly apartments near Highland Elementary in Moreno Valley East. Welcome to Rancho Belago.",
      "page_copy": "Rancho Belago offers family-friendly living with apartments conveniently located near Highland Elementary in Moreno Valley East. Our spacious one, two, and three-bedroom floor plans provide the perfect home environment with modern features such as granite countertops and crown molding.\n\nThis community is ideal for families with school-age children, providing easy access to Highland Elementary and a nurturing neighborhood atmosphere. Residents can enjoy our vibrant amenities, including a clubhouse perfect for community events and walking trails for family outings. Make Rancho Belago your home, where convenience meets comfort in Moreno Valley East.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a double sink.",
        "public_id": "019d01a2-a4d0-700e-9c5d-639e8431d980",
        "storage_key": "property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Highland Elementary, Moreno Valley East",
      "seo_description": "Find ideal apartments near Highland Elementary in Moreno Valley East. Enjoy modern living at Rancho Belago with family-friendly amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "generator",
      "page_item_url": "moreno-elementary-school-vicinity-apartments",
      "search_query": "moreno elementary school vicinity apartments",
      "category": "School",
      "h1_title": "Apartments Near Moreno Elementary School",
      "h2_subtitle": "Explore apartments in the vicinity of Moreno Elementary School. Discover modern living at Rancho Belago.",
      "page_copy": "Rancho Belago offers a prime location for those seeking apartments in the vicinity of Moreno Elementary School. Our community boasts a selection of one, two, and three-bedroom floor plans with elegant interiors, including granite countertops and crown molding, providing a stylish and comfortable home environment.\n\nLiving close to Moreno Elementary School, families appreciate the short commute and family-friendly community. Rancho Belago also offers a range of amenities like a dynamic resident clubhouse and scenic walking trails, enhancing your living experience in Moreno Valley. Make Rancho Belago your new home and enjoy the convenience and warmth of a welcoming community near essential educational facilities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a double sink.",
        "public_id": "019d01a2-a4d0-700e-9c5d-639e8431d980",
        "storage_key": "property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Moreno Elementary School",
      "seo_description": "Discover modern apartments near Moreno Elementary School. Enjoy the comfort and amenities of Rancho Belago, a family-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "generator",
      "page_item_url": "residences-near-mountain-view-middle-ca",
      "search_query": "residences near mountain view middle ca",
      "category": "School",
      "h1_title": "Residences Near Mountain View Middle, CA",
      "h2_subtitle": "Find the perfect residence near Mountain View Middle School, CA. Rancho Belago offers modern living spaces in a welcoming community.",
      "page_copy": "If you're searching for residences near Mountain View Middle School in CA, look no further than Rancho Belago. Our community provides a wide array of one, two, and three-bedroom apartments designed with contemporary features like granite countertops and crown molding, tailored to fit all lifestyle needs.\n\nConveniently situated near Mountain View Middle School, Rancho Belago is perfect for families seeking proximity to academic institutions. Enjoy community amenities such as a vibrant clubhouse and scenic walking and biking trails, which add life and leisure to the everyday experience. At Rancho Belago, find a residence where educational opportunities and community spirit thrive together.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a double sink.",
        "public_id": "019d01a2-a4d0-700e-9c5d-639e8431d980",
        "storage_key": "property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Residences Near Mountain View Middle, CA",
      "seo_description": "Explore residences near Mountain View Middle School in CA. Rancho Belago offers modern, comfortable living in a community-rich environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "generator",
      "page_item_url": "apartments-around-valley-view-high-moreno-valley",
      "search_query": "apartments around valley view high moreno valley",
      "category": "School",
      "h1_title": "Apartments Around Valley View High, Moreno Valley",
      "h2_subtitle": "Discover convenient apartments around Valley View High in Moreno Valley. Experience exceptional living at Rancho Belago.",
      "page_copy": "At Rancho Belago, find the ideal apartments around Valley View High in Moreno Valley. Offering spacious one, two, and three-bedroom layouts, our community is designed for modern living with features such as granite countertops and crown molding.\n\nLiving here means you're just moments away from Valley View High School, making it an excellent choice for families or anyone who values educational accessibility. Residents can enjoy a variety of amenities, including a vibrant clubhouse and scenic walking trails, providing a balance of work, study, and relaxation. Choose Rancho Belago for a community-focused lifestyle near top local schools.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a double sink.",
        "public_id": "019d01a2-a4d0-700e-9c5d-639e8431d980",
        "storage_key": "property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Around Valley View High, Moreno Valley",
      "seo_description": "Find perfect apartments around Valley View High in Moreno Valley at Rancho Belago. Enjoy modern amenities and a family-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "generator",
      "page_item_url": "sunnymead-montessori-school-area-apts-moreno-valley-east",
      "search_query": "sunnymead montessori school area apts moreno valley east",
      "category": "School",
      "h1_title": "Apts Near Sunnymead Montessori, Moreno Valley East",
      "h2_subtitle": "Explore apts in the Sunnymead Montessori school area. Enjoy comfortable living at Rancho Belago in Moreno Valley East.",
      "page_copy": "Rancho Belago offers outstanding apts near Sunnymead Montessori School in Moreno Valley East. Our thoughtfully designed one, two, and three-bedroom floor plans feature modern amenities like granite countertops and elegant crown molding, perfect for any lifestyle.\n\nNestled in the vibrant Moreno Valley East community, Rancho Belago is ideally located for families looking to stay close to prominent educational facilities like Sunnymead Montessori School. Residents can enjoy a variety of on-site amenities, including a clubhouse for social gathering and scenic walking and biking trails. Make Rancho Belago your home and enjoy a blend of comfort, convenience, and community spirit.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a double sink.",
        "public_id": "019d01a2-a4d0-700e-9c5d-639e8431d980",
        "storage_key": "property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Sunnymead Montessori, Moreno Valley East",
      "seo_description": "Discover comfortable apts near Sunnymead Montessori in Moreno Valley East. Rancho Belago offers modern amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5739272128692224",
      "source": "generator",
      "page_item_url": "rentals-near-calvary-chapel-christian-school-moreno-valley",
      "search_query": "rentals near calvary chapel christian school moreno valley",
      "category": "School",
      "h1_title": "Rentals Near Calvary Chapel Christian School",
      "h2_subtitle": "Discover rentals near Calvary Chapel Christian School in Moreno Valley. Find your ideal home at Rancho Belago, offering modern comforts.",
      "page_copy": "Looking for rentals near Calvary Chapel Christian School in Moreno Valley? Rancho Belago is ideally located to provide easy access to this reputable educational institution while offering comfortable living spaces. Choose from our one, two, or three-bedroom floor plans, each designed with modern amenities like elegant granite countertops and crown molding.\n\nRancho Belago's welcoming community cultivates the perfect environment for families and individuals who value both convenience and quality living. Enjoy on-site amenities, including a sophisticated clubhouse and multiple walking and biking trails, all within a short distance of Calvary Chapel Christian School. Experience community living at its best at Rancho Belago.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a double sink.",
        "public_id": "019d01a2-a4d0-700e-9c5d-639e8431d980",
        "storage_key": "property/5739272128692224/019d01a2-a4d0-700e-9c5d-639e8431d980.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Calvary Chapel Christian School",
      "seo_description": "Find rentals near Calvary Chapel Christian School in Moreno Valley. Rancho Belago offers modern apartments and community-focused living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "4773"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9147444897"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9513795020"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WDQWF4ST"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 2"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "bbc19cb3-43ef-425b-8664-5d7111d4c73c"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Avenue"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/4610c8ba-16f8-41ad-889f-35e999745ef5/app.js?property=4610c8ba-16f8-41ad-889f-35e999745ef5&propertyName=Rancho+Belago&channelUuid=c248ea7f-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47578684069"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Inp4a3RqQU91elVnUU1pZnR5MXdQWXc9PSIsInZhbHVlIjoieSs2d0did0d2VDJSTHg0Tm0ybWNXdz09IiwibWFjIjoiYzdjZTRkNGU2NTQzYjhkZjAxZWYyOTExMTI4NmQ5YTdmMzIyNjkxYTYyMDQ4ZWI0NDk0Zjg3M2I5OTNlMWUzNSJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_qb_id": "4773",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "9147444897",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9513795020",
  "custom_google_gtm_id": "GTM-WDQWF4ST",
  "custom_rollout_phase": "Phase 2",
  "custom_rentgrata_token": "bbc19cb3-43ef-425b-8664-5d7111d4c73c",
  "custom_vibesites_theme": "Avenue",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/4610c8ba-16f8-41ad-889f-35e999745ef5/app.js?property=4610c8ba-16f8-41ad-889f-35e999745ef5&propertyName=Rancho+Belago&channelUuid=c248ea7f-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47578684069",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Inp4a3RqQU91elVnUU1pZnR5MXdQWXc9PSIsInZhbHVlIjoieSs2d0did0d2VDJSTHg0Tm0ybWNXdz09IiwibWFjIjoiYzdjZTRkNGU2NTQzYjhkZjAxZWYyOTExMTI4NmQ5YTdmMzIyNjkxYTYyMDQ4ZWI0NDk0Zjg3M2I5OTNlMWUzNSJ9",
  "custom_audioeye_site_id": "3a76841a-79dd-4796-9da7-a1c26d61f240",
  "custom_audioeye_site_hash": "8970cf399ed91dca60cc2fd9e8f1df2a"
};

export const generatedAt = '2026-10-28T17:36:15.717Z';
